/* Verified Maybach dealer database. */
window.MaybachDealerData = Object.freeze([
  {
    "name": "Adi's Guitar",
    "address": "Moosmahdstraße 9",
    "city": "Dornbirn",
    "postcode": "6850",
    "countryCode": "AT",
    "country": "Austria",
    "telephone": "+43 660 3492411",
    "email": "office@adis-guitar.at",
    "website": "https://www.adis-guitar.at/",
    "latitude": 47.4135217,
    "longitude": 9.7370558,
    "id": "82cd36c62d7e",
    "searchPlaces": [
      "Dornbirn"
    ],
    "status": "closed"
  },
  {
    "name": "Guitars & MORE",
    "address": "Katzenberg 57",
    "city": "Kirchdorf am Inn",
    "postcode": "4982",
    "countryCode": "AT",
    "country": "Austria",
    "telephone": "+43 650 8882505",
    "email": "info@gitarrenladen.com",
    "website": "http://www.gitarrenladen.com/",
    "latitude": 48.2895904,
    "longitude": 13.2971688,
    "id": "d120595ea7d4",
    "searchPlaces": [
      "Sankt Georgen bei Obernberg am Inn"
    ],
    "status": "renamed"
  },
  {
    "name": "KEY-WI MUSIC GmbH",
    "address": "Itzlinger Hauptstraße 35",
    "city": "Salzburg",
    "postcode": "5020",
    "countryCode": "AT",
    "country": "Austria",
    "telephone": "+43 662 848410",
    "email": "info@keywi.com",
    "website": "http://www.keywi.com/",
    "latitude": 47.822459,
    "longitude": 13.0440734,
    "id": "df3f99b86141",
    "searchPlaces": [
      "Salzburg"
    ],
    "status": "active"
  },
  {
    "name": "Klangfarbe",
    "address": "Guglgasse 14 Gasometer D",
    "city": "Vienna",
    "postcode": "1110",
    "countryCode": "AT",
    "country": "Austria",
    "telephone": "+43 1 5451717",
    "email": "",
    "website": "https://www.klangfarbe.com/",
    "latitude": 48.1850834,
    "longitude": 16.4211756,
    "id": "b3adc5fe5f67",
    "searchPlaces": [
      "Simmering",
      "Landstraße",
      "Favoriten",
      "Vienna",
      "Margareten",
      "Aspern",
      "Donaustadt",
      "Meidling"
    ],
    "status": "active"
  },
  {
    "name": "Musik Hammer GmbH",
    "address": "Storchgasse 4",
    "city": "Graz",
    "postcode": "8020",
    "countryCode": "AT",
    "country": "Austria",
    "telephone": "+43 316 722000",
    "email": "office@musikhammer.at",
    "website": "https://www.musikhammer.at/",
    "latitude": 47.06663,
    "longitude": 15.433296,
    "id": "1195f25ba01b",
    "searchPlaces": [
      "Innere Stadt",
      "Graz"
    ],
    "status": "active"
  },
  {
    "name": "Musikhaus Hergeth",
    "address": "Burggasse 23",
    "city": "Klagenfurt am Wörthersee",
    "postcode": "9020",
    "countryCode": "AT",
    "country": "Austria",
    "telephone": "+43 463 57991",
    "email": "office@musik-hergeth.at",
    "website": "https://www.musik-hergeth.at/",
    "latitude": 46.6244444,
    "longitude": 14.3111146,
    "id": "41c8ed099ff2",
    "searchPlaces": [
      "2.Bezirk",
      "Klagenfurt am Wörthersee",
      "Klagenfurt am Woerthersee"
    ],
    "status": "active"
  },
  {
    "name": "AZZATO - music store LLN",
    "address": "Rue des Wallons 20",
    "city": "Ottignies-Louvain-la-Neuve",
    "postcode": "1348",
    "countryCode": "BE",
    "country": "Belgium",
    "telephone": "+32 10 45 88 49",
    "email": "nicdory@gmail.com",
    "website": "http://www.azzato.eu/",
    "latitude": 50.6687628,
    "longitude": 4.6165806,
    "id": "6e71af208175",
    "searchPlaces": [
      "Louvain-la-Neuve",
      "Woluwe-Saint-Lambert",
      "Leuven",
      "Uccle",
      "Ixelles",
      "Saint-Gilles",
      "Forest",
      "Brussels"
    ],
    "status": "active"
  },
  {
    "name": "LL Music Center",
    "address": "Burgemeester Philipslaan 110",
    "city": "Maaseik",
    "postcode": "3680",
    "countryCode": "BE",
    "country": "Belgium",
    "telephone": "+32 89 56 89 58",
    "email": "info@llmusiccenter.com",
    "website": "http://www.llmusiccenter.com/",
    "latitude": 51.096721,
    "longitude": 5.786673,
    "id": "1136733484d3",
    "searchPlaces": [
      "Maaseik",
      "Genk"
    ],
    "status": "active"
  },
  {
    "name": "Music store",
    "address": "Industriepark de Bruwaan 67A",
    "city": "Oudenaarde",
    "postcode": "9700",
    "countryCode": "BE",
    "country": "Belgium",
    "telephone": "+32 55 61 39 13",
    "email": "info@muziekhandeloudenaarde.be",
    "website": "http://www.muziekhandeloudenaarde.com/",
    "latitude": 50.848459,
    "longitude": 3.5996504,
    "id": "f3ff392a3327",
    "searchPlaces": [
      "Oudenaarde",
      "Kortrijk",
      "Gent",
      "Mouscron"
    ],
    "status": "active"
  },
  {
    "name": "Muziekhandel Leo Caerts",
    "address": "Naamsestraat 90-92-94, Naamsestraat 90-92-94",
    "city": "Leuven",
    "postcode": "3000",
    "countryCode": "BE",
    "country": "Belgium",
    "telephone": "+32 16 23 07 77",
    "email": "info@leocaerts.be",
    "website": "https://www.leocaerts.be/",
    "latitude": 50.8741544,
    "longitude": 4.6998854,
    "id": "b588d6fb74c4",
    "searchPlaces": [
      "Leuven",
      "Woluwe-Saint-Lambert",
      "Schaerbeek",
      "Mechelen",
      "Ixelles",
      "Brussels",
      "Saint-Gilles",
      "Jette"
    ],
    "status": "active"
  },
  {
    "name": "Omega Music",
    "address": "Av. Joseph Wauters 143",
    "city": "Mons",
    "postcode": "7000",
    "countryCode": "BE",
    "country": "Belgium",
    "telephone": "+32 65 35 51 71",
    "email": "web@omega.be",
    "website": "http://www.omega.be/",
    "latitude": 50.4485245,
    "longitude": 3.9351365,
    "id": "42e20081a6ec",
    "searchPlaces": [
      "Mons",
      "La Louvière",
      "La Louviere"
    ],
    "status": "active"
  },
  {
    "name": "Rockamusic",
    "address": "Rue de la Pavée 7b",
    "city": "Namur",
    "postcode": "5101",
    "countryCode": "BE",
    "country": "Belgium",
    "telephone": "+32 81 58 15 09",
    "email": "info@rockamusic.eu",
    "website": "https://www.rockamusic.eu/",
    "latitude": 50.4473618,
    "longitude": 4.8994151,
    "id": "8cbf05b50b10",
    "searchPlaces": [
      "Erpent",
      "Namur"
    ],
    "status": "active"
  },
  {
    "name": "中雅乐器",
    "address": "",
    "city": "Guangzhou",
    "postcode": "",
    "countryCode": "CN",
    "country": "China",
    "telephone": "",
    "email": "",
    "website": "",
    "latitude": 23.138717,
    "longitude": 113.333484,
    "id": "e53de3f5bb3c",
    "searchPlaces": [
      "Wushan",
      "Guangzhou",
      "Dasha",
      "Shiqiao",
      "Foshan"
    ],
    "status": "uncertain"
  },
  {
    "name": "Evangelismos Music Store",
    "address": "John Kennedy 65",
    "city": "Nicosia",
    "postcode": "1076",
    "countryCode": "CY",
    "country": "Cyprus",
    "telephone": "+357 22 672525",
    "email": "info@evangelismosmusic.com",
    "website": "http://www.evangelismosmusic.com/",
    "latitude": 35.15756,
    "longitude": 33.3673393,
    "id": "23c6aaf96a8c",
    "searchPlaces": [
      "Nicosia",
      "Stróvolos",
      "Strovolos"
    ],
    "status": "active"
  },
  {
    "name": "Huml Music",
    "address": "Nuselská 336/112",
    "city": "Prague 4",
    "postcode": "140 00",
    "countryCode": "CZ",
    "country": "Czech Republic",
    "telephone": "+420 241 403 648",
    "email": "humlmusic@humlmusic.cz",
    "website": "http://www.humlmusic.cz/",
    "latitude": 50.0559445,
    "longitude": 14.4510722,
    "id": "dd33a1a2be80",
    "searchPlaces": [
      "Michle",
      "Žižkov",
      "Zizkov",
      "Prague",
      "Chodov",
      "Stodůlky",
      "Stodulky",
      "Kladno"
    ],
    "status": "active"
  },
  {
    "name": "Akustikken",
    "address": "Bagerstræde 7",
    "city": "Copenhagen Municipality",
    "postcode": "1617",
    "countryCode": "DK",
    "country": "Denmark",
    "telephone": "+45 86 12 60 34",
    "email": "info@akustikken.dk",
    "website": "https://www.akustikken.dk/",
    "latitude": 55.6731087,
    "longitude": 12.5544503,
    "id": "973a15c0c3a3",
    "searchPlaces": [
      "Copenhagen",
      "Frederiksberg",
      "Hvidovre",
      "Avedøre",
      "Avedore",
      "Roskilde"
    ],
    "status": "active"
  },
  {
    "name": "Akustikken Aarhus",
    "address": "Nørreport 18",
    "city": "Aarhus Municipality",
    "postcode": "8000",
    "countryCode": "DK",
    "country": "Denmark",
    "telephone": "+45 86 12 60 34",
    "email": "info@akustikken.dk",
    "website": "https://akustikken.dk/",
    "latitude": 56.147057,
    "longitude": 10.194601,
    "id": "8592992076bf",
    "searchPlaces": [
      "Århus",
      "Arhus"
    ],
    "status": "active"
  },
  {
    "name": "Vintage and Rare",
    "address": "Strandboulevarden 149, st. th",
    "city": "Copenhagen",
    "postcode": "2100",
    "countryCode": "DK",
    "country": "Denmark",
    "telephone": "+45 31 32 60 18",
    "email": "info@vintageandrare.com",
    "website": "http://www.vintageandrare.com/",
    "latitude": 55.66598,
    "longitude": 12.558768,
    "id": "319abac5460d",
    "searchPlaces": [
      "Copenhagen",
      "Frederiksberg",
      "Hvidovre",
      "Avedøre",
      "Avedore"
    ],
    "status": "active"
  },
  {
    "name": "AR Music",
    "address": "495 Rue de la Martinière",
    "city": "Bassens",
    "postcode": "73000",
    "countryCode": "FR",
    "country": "France",
    "telephone": "+33 4 79 85 19 90",
    "email": "",
    "website": "http://www.ar-music.fr/",
    "latitude": 45.5717534,
    "longitude": 5.9432983,
    "id": "f8510b754fdc",
    "searchPlaces": [
      "Bassens",
      "Chambéry",
      "Chambery"
    ],
    "status": "closed"
  },
  {
    "name": "Axe Musique",
    "address": "4 rue Lochet",
    "city": "Châlons-en-Champagne",
    "postcode": "51000",
    "countryCode": "FR",
    "country": "France",
    "telephone": "+33 3 26 65 74 95",
    "email": "",
    "website": "https://www.axe-musique.fr/",
    "latitude": 48.9556969,
    "longitude": 4.3606517,
    "id": "7ec6e119e51d",
    "searchPlaces": [
      "Châlons-en-Champagne",
      "Chalons-en-Champagne"
    ],
    "status": "active"
  },
  {
    "name": "Backline & Pianos",
    "address": "9 Bd Edmond Michelet",
    "city": "Lyon",
    "postcode": "69008",
    "countryCode": "FR",
    "country": "France",
    "telephone": "+33 4 37 90 25 22",
    "email": "",
    "website": "http://newloc.shop/",
    "latitude": 45.732356,
    "longitude": 4.87702,
    "id": "fa2ff840938c",
    "searchPlaces": [
      "Lyon 08",
      "Lyon",
      "Lyon 07",
      "Villeurbanne",
      "Lyon 03",
      "Vénissieux",
      "Venissieux",
      "Lyon 06"
    ],
    "status": "closed"
  },
  {
    "name": "Backstage Distribution Le Stock",
    "address": "5 avenue Grand Piton",
    "city": "Saint-Paul",
    "postcode": "97460",
    "countryCode": "FR",
    "country": "France",
    "telephone": "",
    "email": "",
    "website": "",
    "latitude": -20.963983,
    "longitude": 55.295582,
    "id": "a2b5ed6cf2af",
    "searchPlaces": [
      "Le Port",
      "Saint-Paul",
      "Saint-Denis"
    ],
    "status": "moved"
  },
  {
    "name": "Bergerac Music",
    "address": "73 Av. Paul Doumer",
    "city": "Bergerac",
    "postcode": "24100",
    "countryCode": "FR",
    "country": "France",
    "telephone": "+33 5 53 57 27 38",
    "email": "",
    "website": "",
    "latitude": 44.8220709,
    "longitude": 0.4793527,
    "id": "748cc66a4910",
    "searchPlaces": [
      "Saint-Laurent-des-Vignes"
    ],
    "status": "active"
  },
  {
    "name": "Burin Musique",
    "address": "2 Rue du Pont Saint-Marcel",
    "city": "Metz",
    "postcode": "57000",
    "countryCode": "FR",
    "country": "France",
    "telephone": "+33 3 87 32 04 13",
    "email": "",
    "website": "http://www.burin.com/",
    "latitude": 49.1211713,
    "longitude": 6.1710672,
    "id": "89b40d83b7e7",
    "searchPlaces": [
      "Metz"
    ],
    "status": "active"
  },
  {
    "name": "Centrale Guitars",
    "address": "8/10, 12/16 Rue de Douai 10bis",
    "city": "Paris",
    "postcode": "75009",
    "countryCode": "FR",
    "country": "France",
    "telephone": "+33 1 42 81 13 15",
    "email": "contact@centraleguitars.com",
    "website": "http://www.centraleguitars.com/",
    "latitude": 48.8815437,
    "longitude": 2.3356099,
    "id": "fe7d5364bd0b",
    "searchPlaces": [
      "Paris 17 Batignolles-Monceau",
      "Paris 09 Opéra",
      "Paris 09 Opera",
      "Paris 18 Buttes-Montmartre",
      "Paris 10e Arrondissement",
      "Paris 10 Entrepôt",
      "Paris 10 Entrepot",
      "Clichy"
    ],
    "status": "active"
  },
  {
    "name": "Custom Guitar Shop",
    "address": "custom guitar shop, 43 Rue du Dr Rahuel",
    "city": "Saint-Brieuc",
    "postcode": "22000",
    "countryCode": "FR",
    "country": "France",
    "telephone": "+33 2 96 61 75 75",
    "email": "customguitarshop22@gmail.com",
    "website": "http://www.custom-guitar-shop.fr/",
    "latitude": 48.5065668,
    "longitude": -2.7469977,
    "id": "422f924286ab",
    "searchPlaces": [
      "Saint-Brieuc"
    ],
    "status": "active"
  },
  {
    "name": "DamicoStore",
    "address": "ZI, 501 Rue Fourny",
    "city": "Buc",
    "postcode": "78530",
    "countryCode": "FR",
    "country": "France",
    "telephone": "+33 1 39 56 12 57",
    "email": "damicomag@aol.com",
    "website": "http://www.damico-store.com/",
    "latitude": 48.764285,
    "longitude": 2.123511,
    "id": "bea4fdb5c8a3",
    "searchPlaces": [
      "Les Loges-en-Josas",
      "Versailles",
      "Saint-Quentin-en-Yvelines",
      "Clamart",
      "Boulogne-Billancourt",
      "Antony",
      "Issy-les-Moulineaux",
      "Rueil-Malmaison"
    ],
    "status": "renamed"
  },
  {
    "name": "Decibel Clinic",
    "address": "10 Rue des Amoureux",
    "city": "Annemasse",
    "postcode": "74100",
    "countryCode": "FR",
    "country": "France",
    "telephone": "+33 7 62 72 26 13",
    "email": "info@decibel-clinic.com",
    "website": "http://www.decibel-clinic.com/",
    "latitude": 46.1906083,
    "longitude": 6.2358927,
    "id": "366cf8a565e9",
    "searchPlaces": [
      "Annemasse"
    ],
    "status": "active"
  },
  {
    "name": "Fallone Music",
    "address": "117 Rue d'Auxonne",
    "city": "Dijon",
    "postcode": "21000",
    "countryCode": "FR",
    "country": "France",
    "telephone": "+33 3 80 68 42 70",
    "email": "commande@fallonemusic.com",
    "website": "http://www.fallonemusic.com/",
    "latitude": 47.3121106,
    "longitude": 5.0518516,
    "id": "8e71bad4467a",
    "searchPlaces": [
      "Dijon"
    ],
    "status": "active"
  },
  {
    "name": "Guitare Avenue",
    "address": "5 Rue de l'Artisanat",
    "city": "Villars",
    "postcode": "42390",
    "countryCode": "FR",
    "country": "France",
    "telephone": "+33 9 66 90 12 21",
    "email": "contact@guitareavenue.fr",
    "website": "http://www.guitareavenue.fr/",
    "latitude": 45.4613675,
    "longitude": 4.3811963,
    "id": "7f21bea05f7d",
    "searchPlaces": [
      "Saint-Priest-en-Jarez",
      "Saint-Étienne",
      "Saint-Etienne"
    ],
    "status": "active"
  },
  {
    "name": "Guitare N' Ko",
    "address": "50 Rue d'Antrain",
    "city": "Rennes",
    "postcode": "35700",
    "countryCode": "FR",
    "country": "France",
    "telephone": "+33 2 99 36 86 61",
    "email": "guitarenko@gmail.com",
    "website": "http://www.guitarenko.fr/",
    "latitude": 48.116691,
    "longitude": -1.678349,
    "id": "a328834ff97a",
    "searchPlaces": [
      "Rennes"
    ],
    "status": "active"
  },
  {
    "name": "Guitare Village",
    "address": "161 Av. Jean Rostand",
    "city": "Domont",
    "postcode": "95330",
    "countryCode": "FR",
    "country": "France",
    "telephone": "+33 1 39 91 16 63",
    "email": "contact@guitare-village.com",
    "website": "https://www.guitare-village.com/",
    "latitude": 49.0400764,
    "longitude": 2.3392296,
    "id": "0f05c1f58f0c",
    "searchPlaces": [
      "Moisselles",
      "Sarcelles",
      "Saint-Denis",
      "Argenteuil",
      "Aubervilliers",
      "Asnières-sur-Seine",
      "Asnieres-sur-Seine",
      "Sartrouville"
    ],
    "status": "active"
  },
  {
    "name": "Guitares Gam",
    "address": "42 Av. Jacques Cœur",
    "city": "Poitiers",
    "postcode": "86000",
    "countryCode": "FR",
    "country": "France",
    "telephone": "",
    "email": "",
    "website": "",
    "latitude": 46.5715459,
    "longitude": 0.3686052,
    "id": "35e480058493",
    "searchPlaces": [
      "Poitiers"
    ],
    "status": "closed"
  },
  {
    "name": "Hurricane Music Nantes Pole Sud",
    "address": "Pôle Sud, 12 All. des Cinq Continents",
    "city": "Vertou",
    "postcode": "44120",
    "countryCode": "FR",
    "country": "France",
    "telephone": "+33 2 49 62 10 00",
    "email": "info@hurricanemusic.fr",
    "website": "http://www.hurricanemusic.fr/",
    "latitude": 47.184049,
    "longitude": -1.461413,
    "id": "b549a10fa865",
    "searchPlaces": [
      "Vertou",
      "Nantes"
    ],
    "status": "active"
  },
  {
    "name": "L'Accord Parfait",
    "address": "5 rue Gambetta",
    "city": "Reims",
    "postcode": "51100",
    "countryCode": "FR",
    "country": "France",
    "telephone": "+33 3 26 47 33 68",
    "email": "",
    "website": "https://accord-parfait.fr/",
    "latitude": 49.250696,
    "longitude": 4.035586,
    "id": "ffb36d99cfd3",
    "searchPlaces": [
      "Reims"
    ],
    "status": "active"
  },
  {
    "name": "La Clé de Sol",
    "address": "5 Pl. Dorian",
    "city": "Montbéliard",
    "postcode": "25200",
    "countryCode": "FR",
    "country": "France",
    "telephone": "+33 3 81 34 75 09",
    "email": "contact@lacledesol-montbeliard.com",
    "website": "http://www.lacledesol-montbeliard.com/",
    "latitude": 47.5083211,
    "longitude": 6.7957503,
    "id": "968142cbfe93",
    "searchPlaces": [
      "Montbéliard",
      "Montbeliard",
      "Belfort"
    ],
    "status": "closed"
  },
  {
    "name": "Le Diapason Musipro SARL",
    "address": "2 Av. Roland Garros",
    "city": "Trouy",
    "postcode": "18570",
    "countryCode": "FR",
    "country": "France",
    "telephone": "+33 2 48 25 98 30",
    "email": "le.diapason@orange.fr",
    "website": "https://www.instrument-musique-diapason.fr/",
    "latitude": 47.063161,
    "longitude": 2.385014,
    "id": "df76d4ceff6a",
    "searchPlaces": [
      "Bourges"
    ],
    "status": "active"
  },
  {
    "name": "Le Gaucher",
    "address": "11 rue de Douai",
    "city": "Paris",
    "postcode": "75009",
    "countryCode": "FR",
    "country": "France",
    "telephone": "+33 1 49 70 05 55",
    "email": "legaucherparis@gmail.com",
    "website": "https://www.facebook.com/legaucherparis/",
    "latitude": 48.881446,
    "longitude": 2.33526,
    "id": "c2faa49c1e56",
    "searchPlaces": [
      "Paris 17 Batignolles-Monceau",
      "Paris 09 Opéra",
      "Paris 09 Opera",
      "Paris 18 Buttes-Montmartre",
      "Paris 10e Arrondissement",
      "Paris 10 Entrepôt",
      "Paris 10 Entrepot",
      "Clichy"
    ],
    "status": "active"
  },
  {
    "name": "Luthimate",
    "address": "10 Rue des Champs Pluviers",
    "city": "Sens",
    "postcode": "89100",
    "countryCode": "FR",
    "country": "France",
    "telephone": "+33 3 86 67 05 95",
    "email": "contact@luthimate.fr",
    "website": "http://www.luthimate.fr/",
    "latitude": 48.1946464,
    "longitude": 3.320894,
    "id": "77905dc3eecf",
    "searchPlaces": [
      "Maillot"
    ],
    "status": "active"
  },
  {
    "name": "La Maison de Piano",
    "address": "373 Av. de Paris",
    "city": "Niort",
    "postcode": "79000",
    "countryCode": "FR",
    "country": "France",
    "telephone": "+33 5 49 24 09 46",
    "email": "",
    "website": "",
    "latitude": 46.3327801,
    "longitude": -0.4351522,
    "id": "ee1b1b9273d8",
    "searchPlaces": [
      "Niort"
    ],
    "status": "renamed"
  },
  {
    "name": "Medium Musique",
    "address": "22 Rue Camille Saint-Saëns",
    "city": "Rouen",
    "postcode": "76000",
    "countryCode": "FR",
    "country": "France",
    "telephone": "+33 2 35 89 79 03",
    "email": "",
    "website": "https://mediummusique76.wixsite.com/medium-musique",
    "latitude": 49.440209,
    "longitude": 1.09076,
    "id": "23957a6bd942",
    "searchPlaces": [
      "Rouen"
    ],
    "status": "active"
  },
  {
    "name": "Music City - nuostore.com - Instruments de musique et sonorisation",
    "address": "Les Cadelis E",
    "city": "Angoulins",
    "postcode": "17690",
    "countryCode": "FR",
    "country": "France",
    "telephone": "+33 5 46 45 22 22",
    "email": "contact@nuostore.com",
    "website": "http://www.nuostore.com/",
    "latitude": 46.1031362,
    "longitude": -1.0925237,
    "id": "3f50fee061ef",
    "searchPlaces": [
      "Angoulins",
      "La Rochelle"
    ],
    "status": "active"
  },
  {
    "name": "Michelsonne",
    "address": "81 Rte de Colmar",
    "city": "Sélestat",
    "postcode": "67600",
    "countryCode": "FR",
    "country": "France",
    "telephone": "+33 3 88 92 13 74",
    "email": "contact@michelsonne.com",
    "website": "https://michelsonne.com/",
    "latitude": 48.2520188,
    "longitude": 7.4390767,
    "id": "a4585c9217c5",
    "searchPlaces": [
      "Sélestat",
      "Selestat",
      "Colmar"
    ],
    "status": "active"
  },
  {
    "name": "Music Store 63",
    "address": "41 Bd Aristide Briand",
    "city": "Clermont-Ferrand",
    "postcode": "63000",
    "countryCode": "FR",
    "country": "France",
    "telephone": "+33 4 73 34 17 12",
    "email": "contact@musicstore63.fr",
    "website": "http://www.musicstore63.com/",
    "latitude": 45.770165,
    "longitude": 3.076356,
    "id": "5176d982b307",
    "searchPlaces": [
      "Chamalières",
      "Chamalieres",
      "Clermont-Ferrand"
    ],
    "status": "active"
  },
  {
    "name": "Musique Shop",
    "address": "26 rue de l'Industrie",
    "city": "Illkirch-Graffenstaden",
    "postcode": "67400",
    "countryCode": "FR",
    "country": "France",
    "telephone": "+33 3 88 36 33 58",
    "email": "contact@musique-shop.fr",
    "website": "https://www.musique-shop.fr/",
    "latitude": 48.5754252,
    "longitude": 7.7573483,
    "id": "8c9e2fdaa56a",
    "searchPlaces": [
      "Strasbourg"
    ],
    "status": "moved"
  },
  {
    "name": "La Teste Musique",
    "address": "520 Av. Gustave Eiffel",
    "city": "La Teste-de-Buch",
    "postcode": "33260",
    "countryCode": "FR",
    "country": "France",
    "telephone": "+33 5 57 15 93 83",
    "email": "",
    "website": "https://www.latestemusique.fr/",
    "latitude": 44.610279,
    "longitude": -1.122455,
    "id": "26e356eadc65",
    "searchPlaces": [
      "La Teste-de-Buch"
    ],
    "status": "active"
  },
  {
    "name": "Paolin Musique",
    "address": "73 Av. Paul Doumer",
    "city": "Bergerac",
    "postcode": "24100",
    "countryCode": "FR",
    "country": "France",
    "telephone": "+33 5 53 57 27 38",
    "email": "paolinmusique33@gmail.com",
    "website": "http://www.paolin-musique.fr/",
    "latitude": 44.505951,
    "longitude": 0.149051,
    "id": "035280bdd4a7",
    "searchPlaces": [
      "Marmande"
    ],
    "status": "moved"
  },
  {
    "name": "Silver Wolf Music",
    "address": "13 Av. Marcel Dassault",
    "city": "Lons",
    "postcode": "64140",
    "countryCode": "FR",
    "country": "France",
    "telephone": "+33 5 59 27 93 82",
    "email": "",
    "website": "https://shop.silverwolfmusic.fr/",
    "latitude": 43.302009,
    "longitude": -0.414817,
    "id": "ad346b6cf49d",
    "searchPlaces": [
      "Billère",
      "Billere",
      "Pau"
    ],
    "status": "active"
  },
  {
    "name": "Sud Musique",
    "address": "4 Av. du Général Leclerc",
    "city": "Arles",
    "postcode": "13200",
    "countryCode": "FR",
    "country": "France",
    "telephone": "+33 4 90 49 62 17",
    "email": "contact@sudmusique.eu",
    "website": "http://www.sudmusique.eu/",
    "latitude": 43.6744396,
    "longitude": 4.6249822,
    "id": "5a887b010aeb",
    "searchPlaces": [
      "Arles",
      "Nîmes",
      "Nimes"
    ],
    "status": "active"
  },
  {
    "name": "Trocnroll",
    "address": "150 Rue Corindon",
    "city": "Éguilles",
    "postcode": "13510",
    "countryCode": "FR",
    "country": "France",
    "telephone": "+33 4 42 38 20 74",
    "email": "contact@trocnroll.com",
    "website": "https://trocnroll.com/",
    "latitude": 43.5328511,
    "longitude": 5.446614,
    "id": "c3d6b4dc2990",
    "searchPlaces": [
      "Aix-en-Provence",
      "Marseille 15",
      "Marseille 14",
      "Marseille 13",
      "Marseille 12",
      "Marseille",
      "Marseille 11",
      "Marseille 10"
    ],
    "status": "uncertain"
  },
  {
    "name": "Veitz Guitars",
    "address": "10 Rue Fix",
    "city": "Strasbourg",
    "postcode": "67100",
    "countryCode": "FR",
    "country": "France",
    "telephone": "+33 3 88 84 01 63",
    "email": "",
    "website": "http://www.veitzguitars.fr/",
    "latitude": 48.5680005,
    "longitude": 7.7589608,
    "id": "69586f0c01f2",
    "searchPlaces": [
      "Strasbourg"
    ],
    "status": "active"
  },
  {
    "name": "Véran Musique",
    "address": "11 bis avenue d'Aléry",
    "city": "Annecy",
    "postcode": "74000",
    "countryCode": "FR",
    "country": "France",
    "telephone": "+33 4 50 45 09 53",
    "email": "contact@veran-musique.fr",
    "website": "https://veran-musique.fr/",
    "latitude": 45.8996561,
    "longitude": 6.1194854,
    "id": "428df6f83463",
    "searchPlaces": [
      "Annecy"
    ],
    "status": "active"
  },
  {
    "name": "Guitars-Shop",
    "address": "Hauptstraße 39a",
    "city": "Hochstadt",
    "postcode": "76879",
    "countryCode": "DE",
    "country": "Germany",
    "telephone": "+49 170 9155604",
    "email": "info@guitars-shop.de",
    "website": "https://guitars-shop.de/",
    "latitude": 49.2395824,
    "longitude": 8.2019823,
    "id": "2259cf371836",
    "searchPlaces": [
      "Hochstadt",
      "Neustadt an der Weinstraße",
      "Speyer",
      "Karlsruhe"
    ],
    "status": "active"
  },
  {
    "name": "MJ Guitars GmbH",
    "address": "Pariser Str. 32",
    "city": "Munich",
    "postcode": "81667",
    "countryCode": "DE",
    "country": "Germany",
    "telephone": "+49 89 483351",
    "email": "shop@mjguitars.de",
    "website": "https://www.mjguitars.de/",
    "latitude": 48.1277209,
    "longitude": 11.5994236,
    "id": "749236801b12",
    "searchPlaces": [
      "Munich",
      "Bogenhausen"
    ],
    "status": "active"
  },
  {
    "name": "Beyer´s Music GmbH",
    "address": "Kantstraße 26",
    "city": "Wattenscheid",
    "postcode": "44867",
    "countryCode": "DE",
    "country": "Germany",
    "telephone": "+49 2327 3939",
    "email": "order@beyers-music.de",
    "website": "https://beyers-music.de/",
    "latitude": 51.46993,
    "longitude": 7.13181,
    "id": "adc1476eda0b",
    "searchPlaces": [
      "Wattenscheid",
      "Gelsenkirchen",
      "Bochum",
      "Essen",
      "Hattingen",
      "Herne",
      "Herten",
      "Gladbeck"
    ],
    "status": "active"
  },
  {
    "name": "Musikhaus Citymusic",
    "address": "Am Johanneskreuz 2",
    "city": "Bonn",
    "postcode": "53111",
    "countryCode": "DE",
    "country": "Germany",
    "telephone": "+49 228 9813455",
    "email": "gitarren@citymusicbonn.de",
    "website": "http://www.citymusicbonn.de/",
    "latitude": 50.741596,
    "longitude": 7.098076,
    "id": "bbbb8d7c8587",
    "searchPlaces": [
      "Bonn",
      "Sankt Augustin",
      "Troisdorf",
      "Porz am Rhein",
      "Rodenkirchen",
      "Hürth",
      "Huerth",
      "Erftstadt"
    ],
    "status": "active"
  },
  {
    "name": "Cream Music Instruments Musikhaus Hummel GmbH",
    "address": "Seehofstraße 6",
    "city": "Frankfurt am Main",
    "postcode": "60594",
    "countryCode": "DE",
    "country": "Germany",
    "telephone": "+49 69 234536",
    "email": "bh@cream-music.shop",
    "website": "http://www.cream-music.shop/",
    "latitude": 50.1062712,
    "longitude": 8.6929436,
    "id": "5456dda307a8",
    "searchPlaces": [
      "Frankfurt am Main",
      "Offenbach",
      "Bad Homburg vor der Höhe",
      "Bad Homburg vor der Hoehe",
      "Hanau am Main",
      "Rüsselsheim am Main",
      "Ruesselsheim am Main",
      "Darmstadt"
    ],
    "status": "closed"
  },
  {
    "name": "Fabiani Guitars - Das Musikhaus in Calw",
    "address": "Altburger Str. 15",
    "city": "Calw",
    "postcode": "75365",
    "countryCode": "DE",
    "country": "Germany",
    "telephone": "+49 7051 78621",
    "email": "fabiani@t-online.de",
    "website": "http://www.fabiani-guitars.de/",
    "latitude": 48.7151496,
    "longitude": 8.736985,
    "id": "9ccbfe0b5ff7",
    "searchPlaces": [
      "Calw",
      "Pforzheim",
      "Sindelfingen"
    ],
    "status": "active"
  },
  {
    "name": "FARM-SOUND Musicshop",
    "address": "Rudolf-Schwander-Straße 11",
    "city": "Kassel",
    "postcode": "34117",
    "countryCode": "DE",
    "country": "Germany",
    "telephone": "+49 171 5433001",
    "email": "laden@farm-sound.de",
    "website": "http://www.farm-sound.de/",
    "latitude": 51.317234,
    "longitude": 9.493767,
    "id": "6d9751e96e3c",
    "searchPlaces": [
      "Kassel"
    ],
    "status": "closed"
  },
  {
    "name": "Guitar Jail",
    "address": "Friedenstraße 4",
    "city": "Bielefeld",
    "postcode": "33602",
    "countryCode": "DE",
    "country": "Germany",
    "telephone": "+49 521 60747",
    "email": "info@guitarjail.de",
    "website": "http://musikwelt-stocksmeier.de/",
    "latitude": 52.0313985,
    "longitude": 8.5275578,
    "id": "3209553f4c1e",
    "searchPlaces": [
      "Bielefeld",
      "Herford",
      "Bad Salzuflen",
      "Gütersloh",
      "Guetersloh",
      "Detmold"
    ],
    "status": "active"
  },
  {
    "name": "American Guitar Shop",
    "address": "Goethestraße 32",
    "city": "Berlin",
    "postcode": "10625",
    "countryCode": "DE",
    "country": "Germany",
    "telephone": "+49 30 3125607",
    "email": "",
    "website": "https://guitar-shop.de/",
    "latitude": 52.50927,
    "longitude": 13.30872,
    "id": "8a39e44fdb8b",
    "searchPlaces": [
      "Charlottenburg",
      "Schöneberg",
      "Schoeneberg",
      "Moabit",
      "Wilmersdorf",
      "Wedding",
      "Steglitz",
      "Steglitz Bezirk"
    ],
    "status": "renamed"
  },
  {
    "name": "Matthias Schulze Guitar-Hospital",
    "address": "Wellinghofer Str. 46",
    "city": "Dortmund",
    "postcode": "44263",
    "countryCode": "DE",
    "country": "Germany",
    "telephone": "+49 231 4257848",
    "email": "dr.mad@guitar-hospital.de",
    "website": "https://www.guitar-hospital.de/",
    "latitude": 51.49071,
    "longitude": 7.49846,
    "id": "9aa1dd79f7ee",
    "searchPlaces": [
      "Hörde",
      "Hoerde",
      "Dortmund",
      "Schwerte",
      "Witten",
      "Lünen",
      "Luenen",
      "Unna"
    ],
    "status": "active"
  },
  {
    "name": "Hardline Music",
    "address": "Friedrich-Engels-Allee 4",
    "city": "Wuppertal",
    "postcode": "42103",
    "countryCode": "DE",
    "country": "Germany",
    "telephone": "+49 202 4468800",
    "email": "info@hardline-music.de",
    "website": "https://www.hardline-music.de/",
    "latitude": 51.2558528,
    "longitude": 7.1596654,
    "id": "5aae37961398",
    "searchPlaces": [
      "Wuppertal",
      "Remscheid",
      "Solingen",
      "Velbert",
      "Hattingen",
      "Hilden",
      "Langenfeld",
      "Ratingen"
    ],
    "status": "active"
  },
  {
    "name": "Hieber Lindberg GmbH",
    "address": "Sonnenstraße 19",
    "city": "Munich",
    "postcode": "80331",
    "countryCode": "DE",
    "country": "Germany",
    "telephone": "+49 89 551460",
    "email": "info@hieber-lindberg.de",
    "website": "http://www.hieber-lindberg.de/",
    "latitude": 48.1371865,
    "longitude": 11.5654563,
    "id": "dccc3caf0281",
    "searchPlaces": [
      "Munich",
      "Bogenhausen"
    ],
    "status": "active"
  },
  {
    "name": "Just Music GmbH",
    "address": "Oranienstraße 140-142",
    "city": "Berlin",
    "postcode": "10969",
    "countryCode": "DE",
    "country": "Germany",
    "telephone": "+49 30 88775500",
    "email": "service@justmusic.de",
    "website": "https://www.justmusic.de/",
    "latitude": 52.5040465,
    "longitude": 13.408877,
    "id": "4894273ee053",
    "searchPlaces": [
      "Kreuzberg",
      "Mitte",
      "Berlin",
      "Treptow",
      "Neukölln",
      "Neukoelln",
      "Friedrichshain",
      "Friedrichshain Bezirk"
    ],
    "status": "closed"
  },
  {
    "name": "J's Guitarshop",
    "address": "Tuttlinger Str. 18",
    "city": "Emmingen-Liptingen",
    "postcode": "78576",
    "countryCode": "DE",
    "country": "Germany",
    "telephone": "+49 7465 4649947",
    "email": "info@jsguitarshop.de",
    "website": "http://www.jsguitarshop.de/",
    "latitude": 47.93883,
    "longitude": 8.90657,
    "id": "466dfcfb6e4e",
    "searchPlaces": [
      "Emmingen-Liptingen"
    ],
    "status": "active"
  },
  {
    "name": "Köln Guitars",
    "address": "Luxemburger Straße 59-61",
    "city": "Köln",
    "postcode": "50674",
    "countryCode": "DE",
    "country": "Germany",
    "telephone": "+49 221 2826571",
    "email": "",
    "website": "",
    "latitude": 50.9257054,
    "longitude": 6.9383418,
    "id": "04eee7ecc8af",
    "searchPlaces": [
      "Neustadt/Süd",
      "Neustadt/Sued",
      "Köln",
      "Koeln",
      "Nippes",
      "Rodenkirchen",
      "Hürth",
      "Huerth"
    ],
    "status": "uncertain"
  },
  {
    "name": "Lead Guitars",
    "address": "Hebbelstraße 41",
    "city": "Potsdam",
    "postcode": "14469",
    "countryCode": "DE",
    "country": "Germany",
    "telephone": "+49 172 9111689",
    "email": "ralf@lead-guitars.de",
    "website": "http://www.lead-guitars.de/",
    "latitude": 52.4043392,
    "longitude": 13.0619129,
    "id": "25df58a98475",
    "searchPlaces": [
      "Potsdam",
      "Zehlendorf",
      "Lichterfelde",
      "Steglitz",
      "Steglitz Bezirk",
      "Wilmersdorf",
      "Charlottenburg",
      "Schöneberg",
      "Schoeneberg"
    ],
    "status": "active"
  },
  {
    "name": "LKG-Guitars",
    "address": "Dorfgasse 9",
    "city": "Gladenbach",
    "postcode": "35075",
    "countryCode": "DE",
    "country": "Germany",
    "telephone": "+49 6462 709976",
    "email": "",
    "website": "https://www.lkg-guitars.de/",
    "latitude": 50.74986,
    "longitude": 8.5666794,
    "id": "d033e735d9b0",
    "searchPlaces": [
      "Gladenbach",
      "Marburg an der Lahn",
      "Gießen",
      "Wetzlar"
    ],
    "status": "active"
  },
  {
    "name": "Lui's Guitar Garage",
    "address": "Georg-Langbein-Straße 6",
    "city": "Neustadt",
    "postcode": "96465",
    "countryCode": "DE",
    "country": "Germany",
    "telephone": "+49 170 8263005",
    "email": "shop@luis-guitar-garage.com",
    "website": "http://luis-guitar-garage.com/",
    "latitude": 50.32655,
    "longitude": 11.1230501,
    "id": "c39c53bfca86",
    "searchPlaces": [
      "Neustadt bei Coburg"
    ],
    "status": "active"
  },
  {
    "name": "MCP Musikinstrumente",
    "address": "Georgenstraße 38",
    "city": "Amberg",
    "postcode": "92224",
    "countryCode": "DE",
    "country": "Germany",
    "telephone": "+49 9621 915974",
    "email": "info@mcpamberg.de",
    "website": "https://mcpamberg.de/",
    "latitude": 49.443,
    "longitude": 11.86504,
    "id": "63661ddf21d9",
    "searchPlaces": [
      "Amberg"
    ],
    "status": "active"
  },
  {
    "name": "MIB-Music",
    "address": "Kreuzung Wildenkuhlen, Kölner Str. 159",
    "city": "Kierspe",
    "postcode": "58566",
    "countryCode": "DE",
    "country": "Germany",
    "telephone": "+49 2359 2998668",
    "email": "ingbert@mib-music.de",
    "website": "http://www.mib-music.de/",
    "latitude": 51.1239303,
    "longitude": 7.6027908,
    "id": "aa033f7c07ab",
    "searchPlaces": [
      "Kierspe",
      "Lüdenscheid",
      "Luedenscheid",
      "Gummersbach",
      "Hagen",
      "Iserlohn",
      "Remscheid"
    ],
    "status": "active"
  },
  {
    "name": "music point",
    "address": "Friedrich-Ebert-Straße 92",
    "city": "Rheinhausen",
    "postcode": "47226",
    "countryCode": "DE",
    "country": "Germany",
    "telephone": "+49 2065 21122",
    "email": "info@music-point-duisburg.de",
    "website": "http://www.music-point-duisburg.de/",
    "latitude": 51.408997,
    "longitude": 6.7118208,
    "id": "a3da72dc6a6c",
    "searchPlaces": [
      "Rheinhausen",
      "Duisburg",
      "Moers",
      "Mülheim",
      "Muelheim",
      "Oberhausen",
      "Krefeld",
      "Ratingen"
    ],
    "status": "active"
  },
  {
    "name": "Music Store Professional Shop",
    "address": "Istanbulstraße 22-26",
    "city": "Buchforst",
    "postcode": "51103",
    "countryCode": "DE",
    "country": "Germany",
    "telephone": "+49 221 88840",
    "email": "info@musicstore.de",
    "website": "http://www.musicstore.de/",
    "latitude": 50.9457893,
    "longitude": 6.9971594,
    "id": "e96e3fb1d8b5",
    "searchPlaces": [
      "Buchforst",
      "Köln",
      "Koeln",
      "Nippes",
      "Rodenkirchen",
      "Porz am Rhein",
      "Leverkusen",
      "Bergisch Gladbach"
    ],
    "status": "active"
  },
  {
    "name": "music world brilon",
    "address": "Hasselborn 53-55",
    "city": "Brilon",
    "postcode": "59929",
    "countryCode": "DE",
    "country": "Germany",
    "telephone": "+49 2961 97900",
    "email": "",
    "website": "http://www.musicworldbrilon.de/",
    "latitude": 51.403898,
    "longitude": 8.57474,
    "id": "e45d6cfa72d1",
    "searchPlaces": [
      "Brilon"
    ],
    "status": "active"
  },
  {
    "name": "music-station piano werner GmbH",
    "address": "Keltenstraße 10",
    "city": "Aiterhofen",
    "postcode": "94330",
    "countryCode": "DE",
    "country": "Germany",
    "telephone": "+49 9421 99700",
    "email": "info@music-station.eu",
    "website": "http://www.music-station.de/",
    "latitude": 48.8433275,
    "longitude": 12.6248977,
    "id": "8f4bcf83dddd",
    "searchPlaces": [
      "Aiterhofen"
    ],
    "status": "active"
  },
  {
    "name": "Musicline",
    "address": "Memmingerstraße 39",
    "city": "Neu-Ulm",
    "postcode": "89231",
    "countryCode": "DE",
    "country": "Germany",
    "telephone": "+49 731 85017",
    "email": "info@musicline24.de",
    "website": "https://musicline24.de/",
    "latitude": 48.387471,
    "longitude": 10.0023913,
    "id": "b70922cd62af",
    "searchPlaces": [
      "Neu-Ulm",
      "Ulm"
    ],
    "status": "active"
  },
  {
    "name": "Musicpoint Rothenburg",
    "address": "Galgengasse 48",
    "city": "Rothenburg ob der Tauber",
    "postcode": "91541",
    "countryCode": "DE",
    "country": "Germany",
    "telephone": "+49 9861 976400",
    "email": "info@musicpoint-rothenburg.de",
    "website": "http://www.musicpoint-rothenburg.de/",
    "latitude": 49.3792111,
    "longitude": 10.1833797,
    "id": "57f46579d49e",
    "searchPlaces": [
      "Rothenburg ob der Tauber"
    ],
    "status": "active"
  },
  {
    "name": "Musik Baum",
    "address": "Plittersdorfer Str. 9a",
    "city": "Bonn",
    "postcode": "53173",
    "countryCode": "DE",
    "country": "Germany",
    "telephone": "+49 228 352512",
    "email": "",
    "website": "https://musikbaum.de/",
    "latitude": 50.687139,
    "longitude": 7.153333,
    "id": "e504c261c77f",
    "searchPlaces": [
      "Friesdorf",
      "Bonn",
      "Sankt Augustin",
      "Troisdorf",
      "Porz am Rhein",
      "Rodenkirchen",
      "Euskirchen",
      "Hürth",
      "Huerth"
    ],
    "status": "active"
  },
  {
    "name": "Musik Hoffmann",
    "address": "Splieterstraße 35",
    "city": "Warendorf",
    "postcode": "48231",
    "countryCode": "DE",
    "country": "Germany",
    "telephone": "+49 2581 63969",
    "email": "musikhoffmann@aol.com",
    "website": "http://www.musik-hoffmann.de/",
    "latitude": 51.9466133,
    "longitude": 8.0022039,
    "id": "994dbc4ba201",
    "searchPlaces": [
      "Warendorf",
      "Ahlen",
      "Münster",
      "Muenster",
      "Gütersloh",
      "Guetersloh"
    ],
    "status": "active"
  },
  {
    "name": "Musik Klier",
    "address": "Wölckernstraße 29",
    "city": "Nuremberg",
    "postcode": "90459",
    "countryCode": "DE",
    "country": "Germany",
    "telephone": "+49 911 439900",
    "email": "info@musik-klier.de",
    "website": "https://www.musik-klier.de/?utm_medium=google-my-business",
    "latitude": 49.44107,
    "longitude": 11.0836001,
    "id": "ee6e213a078d",
    "searchPlaces": [
      "Nuremberg",
      "Fürth",
      "Fuerth",
      "Erlangen"
    ],
    "status": "active"
  },
  {
    "name": "Musik Produktiv",
    "address": "Fuggerstraße 6",
    "city": "Ibbenbüren",
    "postcode": "49479",
    "countryCode": "DE",
    "country": "Germany",
    "telephone": "+49 5451 9090",
    "email": "bestellservice@musik-produktiv.de",
    "website": "https://www.musik-produktiv.de/",
    "latitude": 52.26204,
    "longitude": 7.77488,
    "id": "5f8b28e3bd22",
    "searchPlaces": [
      "Ibbenbueren",
      "Osnabrück",
      "Osnabrueck",
      "Rheine"
    ],
    "status": "active"
  },
  {
    "name": "Musik Wittl",
    "address": "Haidpl. 1",
    "city": "Regensburg",
    "postcode": "93047",
    "countryCode": "DE",
    "country": "Germany",
    "telephone": "+49 941 55892",
    "email": "anfrage@musik-wittl.de",
    "website": "https://regensburg.musik-wittl.de/",
    "latitude": 49.01986,
    "longitude": 12.09368,
    "id": "11a8e9d5942f",
    "searchPlaces": [
      "Regensburg"
    ],
    "status": "active"
  },
  {
    "name": "Musik-Center Scharte e.K.",
    "address": "Thüler Str. 4",
    "city": "Salzkotten",
    "postcode": "33154",
    "countryCode": "DE",
    "country": "Germany",
    "telephone": "+49 5258 5555",
    "email": "",
    "website": "http://www.musik-center.de/",
    "latitude": 51.6741647,
    "longitude": 8.6084109,
    "id": "3c9003dd78fa",
    "searchPlaces": [
      "Salzkotten",
      "Paderborn",
      "Lippstadt"
    ],
    "status": "active"
  },
  {
    "name": "Musikbroedel",
    "address": "",
    "city": "Bottrop",
    "postcode": "46236",
    "countryCode": "DE",
    "country": "Germany",
    "telephone": "",
    "email": "",
    "website": "",
    "latitude": 51.5236381,
    "longitude": 6.9273263,
    "id": "746b16df73fa",
    "searchPlaces": [
      "Bottrop",
      "Gladbeck",
      "Oberhausen",
      "Essen",
      "Mülheim",
      "Muelheim",
      "Gelsenkirchen",
      "Dinslaken"
    ],
    "status": "uncertain"
  },
  {
    "name": "Musikhaus Arthur Knopp GmbH",
    "address": "Str. des 13. Januar 31",
    "city": "Saarbrücken",
    "postcode": "66121",
    "countryCode": "DE",
    "country": "Germany",
    "telephone": "+49 681 3098870",
    "email": "info@musikatelier-knopp.de",
    "website": "https://www.musikatelier-knopp.de/",
    "latitude": 49.2362584,
    "longitude": 6.9941952,
    "id": "eab2246f13de",
    "searchPlaces": [
      "Saarbrücken",
      "Saarbruecken"
    ],
    "status": "active"
  },
  {
    "name": "Musikhaus Funken",
    "address": "Kleinbahnstraße 20",
    "city": "Kempen",
    "postcode": "47906",
    "countryCode": "DE",
    "country": "Germany",
    "telephone": "+49 2152 517763",
    "email": "info@musikhausfunken.de",
    "website": "http://musikhausfunken.de/",
    "latitude": 51.3697577,
    "longitude": 6.4230708,
    "id": "8d4ce2362f95",
    "searchPlaces": [
      "Kempen",
      "Krefeld",
      "Viersen",
      "Willich",
      "Moers",
      "Rheinhausen",
      "Mönchengladbach",
      "Moenchengladbach"
    ],
    "status": "active"
  },
  {
    "name": "Musikhaus Hogrebe",
    "address": "Grosskölnstraße 45",
    "city": "Aachen",
    "postcode": "52062",
    "countryCode": "DE",
    "country": "Germany",
    "telephone": "+49 241 36329",
    "email": "info@musikhaus-hogrebe.de",
    "website": "http://www.musikhaus-hogrebe.de/",
    "latitude": 50.777576,
    "longitude": 6.086743,
    "id": "1cc5d2a065f7",
    "searchPlaces": [
      "Aachen",
      "Stolberg",
      "Eschweiler",
      "Düren",
      "Dueren"
    ],
    "status": "active"
  },
  {
    "name": "Musikhaus Magunia-Engelken GmbH & Co. KG",
    "address": "Am bhf 2",
    "city": "Stade",
    "postcode": "21680",
    "countryCode": "DE",
    "country": "Germany",
    "telephone": "+49 4141 2828",
    "email": "info@musikhaus-stade.de",
    "website": "https://www.musikhaus-stade.de/",
    "latitude": 53.5966156,
    "longitude": 9.4752782,
    "id": "8d90c4262778",
    "searchPlaces": [
      "Hansestadt Stade"
    ],
    "status": "active"
  },
  {
    "name": "Musikhaus Markstein GmbH",
    "address": "Rudolf-Breitscheid-Straße 36",
    "city": "Hartenstein",
    "postcode": "08118",
    "countryCode": "DE",
    "country": "Germany",
    "telephone": "+49 37605 6870",
    "email": "info@markstein.de",
    "website": "http://www.markstein.de/",
    "latitude": 50.663329,
    "longitude": 12.6674296,
    "id": "cf65eb3a910d",
    "searchPlaces": [
      "Hartenstein",
      "Zwickau",
      "Chemnitz"
    ],
    "status": "active"
  },
  {
    "name": "Musikhaus Mollenhauer",
    "address": "Christian-Wirth-Straße 4/EG",
    "city": "Fulda",
    "postcode": "36043",
    "countryCode": "DE",
    "country": "Germany",
    "telephone": "+49 661 941110",
    "email": "info@musik-mollenhauer.de",
    "website": "http://www.musik-mollenhauer.de/",
    "latitude": 50.5280456,
    "longitude": 9.6840772,
    "id": "3c1754f0df56",
    "searchPlaces": [
      "Fulda"
    ],
    "status": "active"
  },
  {
    "name": "Musikladen Bendorf",
    "address": "Rheinstraße 22",
    "city": "Bendorf",
    "postcode": "56170",
    "countryCode": "DE",
    "country": "Germany",
    "telephone": "+49 2622 4344",
    "email": "ttmsoft@t-online.de",
    "website": "https://musikladen.name/xtcommerce/index.php",
    "latitude": 50.41824,
    "longitude": 7.57482,
    "id": "ad437f8603a8",
    "searchPlaces": [
      "Bendorf",
      "Koblenz",
      "Neuwied"
    ],
    "status": "active"
  },
  {
    "name": "Musikhaus Rimmel GmbH",
    "address": "Poststraße 7 - 9",
    "city": "Kempten",
    "postcode": "87435",
    "countryCode": "DE",
    "country": "Germany",
    "telephone": "+49 831 22776",
    "email": "info@musikhausrimmel.de",
    "website": "https://musikhausrimmel.de/",
    "latitude": 47.727373,
    "longitude": 10.310711,
    "id": "d526b4816aff",
    "searchPlaces": [
      "Kempten (Allgäu)",
      "Kempten (Allgaeu)"
    ],
    "status": "active"
  },
  {
    "name": "Musikhaus Thomann",
    "address": "Hans-Thomann-Straße 1",
    "city": "Burgebrach",
    "postcode": "96138",
    "countryCode": "DE",
    "country": "Germany",
    "telephone": "+49 9546 9223-0",
    "email": "kundenservice@thomann.de",
    "website": "https://www.thomann.de/",
    "latitude": 49.80194,
    "longitude": 10.731968,
    "id": "344b8af9ca49",
    "searchPlaces": [
      "Burgebrach",
      "Bamberg"
    ],
    "status": "active"
  },
  {
    "name": "Musikshop Axel",
    "address": "Steinstraße 56",
    "city": "Essen",
    "postcode": "45128",
    "countryCode": "DE",
    "country": "Germany",
    "telephone": "+49 201 230939",
    "email": "info@musik-axel.de",
    "website": "http://www.musik-axel.de/",
    "latitude": 51.447595,
    "longitude": 7.01947,
    "id": "fed7aaf40243",
    "searchPlaces": [
      "Essen",
      "Gelsenkirchen",
      "Wattenscheid",
      "Mülheim",
      "Muelheim",
      "Bottrop",
      "Oberhausen",
      "Velbert"
    ],
    "status": "active"
  },
  {
    "name": "No.1 Guitar Center",
    "address": "Stahltwiete 16",
    "city": "Ottensen",
    "postcode": "22761",
    "countryCode": "DE",
    "country": "Germany",
    "telephone": "+49 40 3910670",
    "email": "info@no1-guitars.de",
    "website": "http://www.no1-guitars.de/",
    "latitude": 53.5617685,
    "longitude": 9.9261209,
    "id": "b165548b3f21",
    "searchPlaces": [
      "Ottensen",
      "Altona",
      "Eimsbüttel",
      "Eimsbuettel",
      "Hamburg",
      "Hamburg-Nord",
      "Hamburg-Mitte",
      "Winterhude"
    ],
    "status": "active"
  },
  {
    "name": "PPC Music GmbH",
    "address": "Alter Flughafen 7A",
    "city": "Hanover",
    "postcode": "30179",
    "countryCode": "DE",
    "country": "Germany",
    "telephone": "+49 511 679980",
    "email": "info@ppcmusic.de",
    "website": "https://www.ppcmusic.de/",
    "latitude": 52.41719,
    "longitude": 9.74189,
    "id": "7c5da31a837d",
    "searchPlaces": [
      "Vahrenheide",
      "Langenhagen",
      "Hannover",
      "Garbsen"
    ],
    "status": "closed"
  },
  {
    "name": "Pro Music Uwe Hopp e. K.",
    "address": "Salzstraße 21",
    "city": "Lüneburg",
    "postcode": "21335",
    "countryCode": "DE",
    "country": "Germany",
    "telephone": "+49 4131 32101",
    "email": "",
    "website": "https://promusic-shop.de/",
    "latitude": 53.2455582,
    "longitude": 10.4017035,
    "id": "4f48f73345d8",
    "searchPlaces": [
      "Lüneburg",
      "Lueneburg",
      "Bergedorf"
    ],
    "status": "active"
  },
  {
    "name": "Rock Shop | Division of fein.media GmbH",
    "address": "Am Sandfeld 21",
    "city": "Karlsruhe",
    "postcode": "76149",
    "countryCode": "DE",
    "country": "Germany",
    "telephone": "+49 721 978550",
    "email": "rockshop@rockshop.de",
    "website": "https://www.rockshop.de/",
    "latitude": 49.0419553,
    "longitude": 8.3926464,
    "id": "0da315175c5f",
    "searchPlaces": [
      "Karlsruhe",
      "Pforzheim"
    ],
    "status": "active"
  },
  {
    "name": "Rockland-Music",
    "address": "Holzkampstraße 37",
    "city": "Witten",
    "postcode": "58453",
    "countryCode": "DE",
    "country": "Germany",
    "telephone": "+49 2302 760926",
    "email": "",
    "website": "http://www.rockland-music.de/",
    "latitude": 51.4408485,
    "longitude": 7.3707577,
    "id": "523064384ea0",
    "searchPlaces": [
      "Witten",
      "Dortmund",
      "Hagen",
      "Bochum",
      "Castrop-Rauxel",
      "Schwerte",
      "Hattingen",
      "Herne"
    ],
    "status": "active"
  },
  {
    "name": "session",
    "address": "Wiesenstraße 2",
    "city": "Walldorf",
    "postcode": "69190",
    "countryCode": "DE",
    "country": "Germany",
    "telephone": "+49 6227 603 0",
    "email": "info@session.de",
    "website": "https://www.session.de/",
    "latitude": 49.2938457,
    "longitude": 8.6628161,
    "id": "be4728df4e18",
    "searchPlaces": [
      "Walldorf",
      "Heidelberg",
      "Speyer",
      "Mannheim",
      "Ludwigshafen am Rhein"
    ],
    "status": "active"
  },
  {
    "name": "Six + Four Bellon + Bieg GmbH",
    "address": "Im Hessenland 14",
    "city": "Sulzbach",
    "postcode": "66280",
    "countryCode": "DE",
    "country": "Germany",
    "telephone": "+49 6897 924940",
    "email": "info@sixandfour.de",
    "website": "https://www.sixandfour.de/",
    "latitude": 49.2996191,
    "longitude": 7.066748,
    "id": "4a457ae2eb6e",
    "searchPlaces": [
      "Sulzbach",
      "Saarbrücken",
      "Saarbruecken"
    ],
    "status": "active"
  },
  {
    "name": "Soundland GmbH",
    "address": "Schorndorfer Str. 25",
    "city": "Fellbach",
    "postcode": "70736",
    "countryCode": "DE",
    "country": "Germany",
    "telephone": "+49 711 5109800",
    "email": "dsb@soundland.de",
    "website": "https://www.soundland.de/",
    "latitude": 48.815281,
    "longitude": 9.2782367,
    "id": "d48c3fa9ad60",
    "searchPlaces": [
      "Fellbach",
      "Waiblingen",
      "Stuttgart",
      "Esslingen",
      "Ludwigsburg",
      "Sindelfingen"
    ],
    "status": "active"
  },
  {
    "name": "station music",
    "address": "Siemensstraße 8",
    "city": "Jettingen-Scheppach",
    "postcode": "89343",
    "countryCode": "DE",
    "country": "Germany",
    "telephone": "+49 8225 958888",
    "email": "",
    "website": "http://www.station-music.de/",
    "latitude": 48.40962,
    "longitude": 10.44136,
    "id": "c22c0b1d3cc4",
    "searchPlaces": [
      "Röfingen",
      "Rofingen"
    ],
    "status": "active"
  },
  {
    "name": "חלילית יפו - סניף ראשי",
    "address": "Retzif HaAliya HaShniya St 8",
    "city": "Tel Aviv-Yafo",
    "postcode": "6812902",
    "countryCode": "IL",
    "country": "Israel",
    "telephone": "+972 3-682-2917",
    "email": "info@halilit.com",
    "website": "http://www.halilit.com/",
    "latitude": 32.055808,
    "longitude": 34.7563398,
    "id": "ea40e56b6dcd",
    "searchPlaces": [
      "Jaffa",
      "Bat Yam",
      "Tel Aviv",
      "H̱olon",
      "Holon",
      "Givatayim",
      "Ramat Gan",
      "Bnei Brak"
    ],
    "status": "active"
  },
  {
    "name": "Cavalli Musica",
    "address": "Via Artigiani, 1",
    "city": "Castrezzato",
    "postcode": "25030",
    "countryCode": "IT",
    "country": "Italy",
    "telephone": "+39 030 714 6657",
    "email": "info@cavallimusica.com",
    "website": "https://www.cavallimusica.com/",
    "latitude": 45.521608,
    "longitude": 9.978755,
    "id": "e1831b7fdc05",
    "searchPlaces": [
      "Castrezzato",
      "Brescia"
    ],
    "status": "active"
  },
  {
    "name": "Stage Music",
    "address": "rue de Luxembourg z.c. Hohkaul",
    "city": "Sandweiler",
    "postcode": "5230",
    "countryCode": "LU",
    "country": "Luxembourg",
    "telephone": "+352 26 15 91",
    "email": "",
    "website": "https://www.stagemusic.lu/",
    "latitude": 49.615198,
    "longitude": 6.206714,
    "id": "1a4c551d3b5d",
    "searchPlaces": [
      "Sandweiler",
      "Luxembourg"
    ],
    "status": "active"
  },
  {
    "name": "Dijkman Music",
    "address": "Rozengracht 115",
    "city": "Amsterdam",
    "postcode": "1016 LV",
    "countryCode": "NL",
    "country": "Netherlands",
    "telephone": "+31 20 626 5611",
    "email": "info@dijkmanmuziek.nl",
    "website": "http://www.dijkmanmuziek.nl/",
    "latitude": 52.372785,
    "longitude": 4.8791852,
    "id": "c2c14e94c52c",
    "searchPlaces": [
      "Amsterdam",
      "Amstelveen",
      "Zaandam",
      "Amsterdam-Zuidoost",
      "Zaanstad",
      "Hoofddorp",
      "Purmerend",
      "Haarlem"
    ],
    "status": "active"
  },
  {
    "name": "Dijkman Music",
    "address": "Limmerhoek 12",
    "city": "Alkmaar",
    "postcode": "1811 BA",
    "countryCode": "NL",
    "country": "Netherlands",
    "telephone": "+31 72 515 2511",
    "email": "info@dijkmanmuziek.nl",
    "website": "http://www.dijkmanmuziek.nl/",
    "latitude": 52.6281961,
    "longitude": 4.7533909,
    "id": "ecea430fa404",
    "searchPlaces": [
      "Alkmaar",
      "Purmerend",
      "Zaanstad",
      "Velsen-Zuid",
      "Hoorn",
      "Zaandam",
      "Haarlem",
      "Amsterdam"
    ],
    "status": "closed"
  },
  {
    "name": "Dijkmans Music",
    "address": "Haagdijk 147",
    "city": "Breda",
    "postcode": "4811 TR",
    "countryCode": "NL",
    "country": "Netherlands",
    "telephone": "+31 76 514 5114",
    "email": "info@dijkmansmuziek.nl",
    "website": "http://www.dijkmansguitars.com/",
    "latitude": 51.586997,
    "longitude": 4.768183,
    "id": "ccee0e12e5fc",
    "searchPlaces": [
      "Breda",
      "Oosterhout",
      "Roosendaal",
      "Tilburg",
      "Dordrecht"
    ],
    "status": "active"
  },
  {
    "name": "Gooise-Gitaren.nl",
    "address": "Stationsweg 40",
    "city": "Bussum",
    "postcode": "1404 AP",
    "countryCode": "NL",
    "country": "Netherlands",
    "telephone": "+31 35 750 6334",
    "email": "info@gooise-gitaren.nl",
    "website": "https://www.gooise-gitaren.nl/",
    "latitude": 52.2803201,
    "longitude": 5.1579162,
    "id": "22ed2cefe529",
    "searchPlaces": [
      "Bussum",
      "Hilversum",
      "Almere Stad",
      "Amsterdam-Zuidoost",
      "Amstelveen",
      "Amersfoort",
      "Amsterdam",
      "Utrecht"
    ],
    "status": "active"
  },
  {
    "name": "Kaj's Guitar Store",
    "address": "Korte Haaksbergerstraat 25",
    "city": "Enschede",
    "postcode": "7511 JV",
    "countryCode": "NL",
    "country": "Netherlands",
    "telephone": "+31 53 574 5515",
    "email": "",
    "website": "http://www.kajsguitarstore.nl/",
    "latitude": 52.2197767,
    "longitude": 6.8926991,
    "id": "fc0f8df2e111",
    "searchPlaces": [
      "Enschede",
      "Hengelo",
      "Almelo"
    ],
    "status": "active"
  },
  {
    "name": "Kauffmann's Guitar Store",
    "address": "Euromarkt 12",
    "city": "Alphen aan den Rijn",
    "postcode": "2408 BL",
    "countryCode": "NL",
    "country": "Netherlands",
    "telephone": "+31 172 417 990",
    "email": "info@kauffmannsguitarstore.com",
    "website": "http://www.kauffmannsguitarstore.com/",
    "latitude": 52.149626,
    "longitude": 4.65969,
    "id": "35a78b68360f",
    "searchPlaces": [
      "Alphen aan den Rijn",
      "Leiden",
      "Gouda",
      "Zoetermeer",
      "Hoofddorp",
      "Amstelveen",
      "Capelle aan den IJssel",
      "Haarlem"
    ],
    "status": "active"
  },
  {
    "name": "Luthiers Gitaren",
    "address": "Vughterstraat 133",
    "city": "'s-Hertogenbosch",
    "postcode": "5211 GB",
    "countryCode": "NL",
    "country": "Netherlands",
    "telephone": "+31 73 614 6174",
    "email": "info@luthiers-gitaren.nl",
    "website": "https://www.luthiers-gitaren.nl/",
    "latitude": 51.6862564,
    "longitude": 5.2981515,
    "id": "e90a5e8388eb",
    "searchPlaces": [
      "'s-Hertogenbosch",
      "Oss",
      "Tilburg",
      "Eindhoven"
    ],
    "status": "active"
  },
  {
    "name": "Prinz Guitars Amsterdam",
    "address": "Prinsengracht 326A",
    "city": "Amsterdam",
    "postcode": "1016 HX",
    "countryCode": "NL",
    "country": "Netherlands",
    "telephone": "+31 6 41432663",
    "email": "",
    "website": "https://www.prinzguitars.nl/",
    "latitude": 52.369123,
    "longitude": 4.882253,
    "id": "3968e244f50f",
    "searchPlaces": [
      "Amsterdam",
      "Amstelveen",
      "Zaandam",
      "Amsterdam-Zuidoost",
      "Zaanstad",
      "Hoofddorp",
      "Purmerend",
      "Haarlem"
    ],
    "status": "closed"
  },
  {
    "name": "Sound City Music",
    "address": "De Onderneming 17",
    "city": "Grootegast",
    "postcode": "9861 AR",
    "countryCode": "NL",
    "country": "Netherlands",
    "telephone": "+31 594 745 684",
    "email": "info@soundcitymusic.nl",
    "website": "http://www.soundcitymusic.nl/",
    "latitude": 53.2141926,
    "longitude": 6.2786421,
    "id": "084607599561",
    "searchPlaces": [
      "Grootegast",
      "Groningen"
    ],
    "status": "active"
  },
  {
    "name": "Stockenhof Music",
    "address": "Rijksstraatweg 193a",
    "city": "Beek-Ubbergen",
    "postcode": "6573 CR",
    "countryCode": "NL",
    "country": "Netherlands",
    "telephone": "+31 24 684 4455",
    "email": "info@stockenhof.nl",
    "website": "http://www.stockenhofmuziek.nl/",
    "latitude": 51.8283,
    "longitude": 5.9269,
    "id": "dc81de594027",
    "searchPlaces": [
      "Berg en Dal",
      "Nijmegen",
      "Arnhem",
      "Oss",
      "Ede"
    ],
    "status": "active"
  },
  {
    "name": "The Fellowship of Acoustics",
    "address": "Moerheimstraat 144",
    "city": "Dedemsvaart",
    "postcode": "7701 CJ",
    "countryCode": "NL",
    "country": "Netherlands",
    "telephone": "+31 523 232 205",
    "email": "info@tfoa.eu",
    "website": "https://www.tfoa.eu/",
    "latitude": 52.60246,
    "longitude": 6.475024,
    "id": "cfb920125a9b",
    "searchPlaces": [
      "Dedemsvaart",
      "Hardenberg",
      "Zwolle"
    ],
    "status": "active"
  },
  {
    "name": "The Guitar Factory Oss",
    "address": "De Schakel 5",
    "city": "Oss",
    "postcode": "5341 CM",
    "countryCode": "NL",
    "country": "Netherlands",
    "telephone": "+31 412 488 145",
    "email": "info@theguitarfactory.nl",
    "website": "http://www.theguitarfactory.nl/",
    "latitude": 51.7685921,
    "longitude": 5.5231651,
    "id": "d97b06575586",
    "searchPlaces": [
      "Oss",
      "'s-Hertogenbosch",
      "Nijmegen",
      "Veenendaal"
    ],
    "status": "active"
  },
  {
    "name": "The Guitar Store",
    "address": "Kerkstraat 30A",
    "city": "Wijhe",
    "postcode": "8131 BZ",
    "countryCode": "NL",
    "country": "Netherlands",
    "telephone": "+31 6 22183569",
    "email": "info@theguitarstore.eu",
    "website": "https://theguitarstore.nl/",
    "latitude": 52.3874273,
    "longitude": 6.1355947,
    "id": "1b39cd988961",
    "searchPlaces": [
      "Wijhe",
      "Zwolle",
      "Deventer",
      "Apeldoorn"
    ],
    "status": "active"
  },
  {
    "name": "Falck Musikk",
    "address": "Fjordgata 11, inngang fra, Brattørveita",
    "city": "Trondheim",
    "postcode": "7010",
    "countryCode": "NO",
    "country": "Norway",
    "telephone": "+47 93 05 76 22",
    "email": "butikk@falckmusikk.no",
    "website": "http://www.falckmusikk.no/",
    "latitude": 63.434432,
    "longitude": 10.401402,
    "id": "d858895d41f6",
    "searchPlaces": [
      "Trondheim"
    ],
    "status": "active"
  },
  {
    "name": "Guitar Lovers ⋆ Guitar Shop",
    "address": "Tv. Cal 67",
    "city": "Fânzeres",
    "postcode": "4510-508",
    "countryCode": "PT",
    "country": "Portugal",
    "telephone": "",
    "email": "geral@guitarlovers.pt",
    "website": "https://www.guitarlovers.pt/",
    "latitude": 41.1563923,
    "longitude": -8.5218823,
    "id": "7b0908600345",
    "searchPlaces": [
      "Fânzeres",
      "Fanzeres",
      "Porto",
      "Vila Nova de Gaia"
    ],
    "status": "active"
  },
  {
    "name": "Gear Crew",
    "address": "20-4 Baekseok-ro 86beon-gil, basement (Baekseok-dong)",
    "city": "Goyang-si",
    "postcode": "10446",
    "countryCode": "KR",
    "country": "South Korea",
    "telephone": "+82 70 4006 1834",
    "email": "iron79k@gmail.com",
    "website": "https://gearcrew.co.kr/",
    "latitude": 37.6471939,
    "longitude": 126.7878777,
    "id": "84689c284bfe",
    "searchPlaces": [
      "Goyang-si",
      "Gimpo-si",
      "Bucheon-si",
      "Seoul",
      "Gwangmyeong",
      "Incheon",
      "Siheungdong",
      "Uijeongbu-si"
    ],
    "status": "active"
  },
  {
    "name": "Al's Music Factory",
    "address": "C. Cabrales, 136, bajo",
    "city": "Gijón",
    "postcode": "33205",
    "countryCode": "ES",
    "country": "Spain",
    "telephone": "+34 609 86 16 87",
    "email": "alsmusic@alsmusicfactory.es",
    "website": "http://www.alsmusicfactory.es/",
    "latitude": 43.534389,
    "longitude": -5.661612,
    "id": "0bb77e57a285",
    "searchPlaces": [
      "Gijón",
      "Gijon",
      "Avilés",
      "Aviles",
      "Oviedo"
    ],
    "status": "active"
  },
  {
    "name": "Alteisa Sonido (Zamora)",
    "address": "Calle Labrador, 7 Poligono Sector 03:Hiniesta Ampl., 7E",
    "city": "Zamora",
    "postcode": "49024",
    "countryCode": "ES",
    "country": "Spain",
    "telephone": "+34 980 51 19 55",
    "email": "info@alteisa.es",
    "website": "https://alteisa.com/",
    "latitude": 41.5250973,
    "longitude": -5.7601061,
    "id": "0a980d9e9a20",
    "searchPlaces": [
      "Zamora"
    ],
    "status": "active"
  },
  {
    "name": "Botiga música Mataró | AUVISA",
    "address": "Via Sèrgia, 86",
    "city": "Mataró",
    "postcode": "08302",
    "countryCode": "ES",
    "country": "Spain",
    "telephone": "+34 937 55 14 99",
    "email": "info@auvisa.com",
    "website": "https://auvisa.com/",
    "latitude": 41.5312775,
    "longitude": 2.4239445,
    "id": "7009d5734917",
    "searchPlaces": [
      "Mataró",
      "Mataro",
      "Granollers",
      "Badalona",
      "Mollet del Vallès",
      "Mollet del Valles",
      "Santa Coloma de Gramenet",
      "Barri de Sant Andreu"
    ],
    "status": "active"
  },
  {
    "name": "Casa Martí",
    "address": "Carrer de la Reina Esclaramunda 5",
    "city": "Palma",
    "postcode": "07003",
    "countryCode": "ES",
    "country": "Spain",
    "telephone": "+34 971 213 294",
    "email": "",
    "website": "https://www.aumallia.com/",
    "latitude": 39.5762371,
    "longitude": 2.6517569,
    "id": "ec9a77408f2d",
    "searchPlaces": [
      "Palma",
      "Calvià",
      "Calvia"
    ],
    "status": "uncertain"
  },
  {
    "name": "Denia Music",
    "address": "Carrer Abu-Zeyan, 15",
    "city": "Dénia",
    "postcode": "03700",
    "countryCode": "ES",
    "country": "Spain",
    "telephone": "+34 965 78 71 26",
    "email": "",
    "website": "https://www.facebook.com/deniamusic",
    "latitude": 38.8390212,
    "longitude": 0.0989572,
    "id": "492b1f3bcd24",
    "searchPlaces": [
      "Denia",
      "Gandia"
    ],
    "status": "active"
  },
  {
    "name": "Drunkat Instrumentos Musicales",
    "address": "Drunkat Instrumentos Musicales, C. Virgen del Carmen, 7",
    "city": "Donostia / San Sebastián",
    "postcode": "20012",
    "countryCode": "ES",
    "country": "Spain",
    "telephone": "+34 943 32 46 18",
    "email": "tienda@drunkat.es",
    "website": "https://drunkat.es/",
    "latitude": 43.3178448,
    "longitude": -1.9691974,
    "id": "f73ad404d8de",
    "searchPlaces": [
      "Donostia / San Sebastián",
      "San Sebastian",
      "Irun"
    ],
    "status": "active"
  },
  {
    "name": "Estudio 54 (Santiago de Compostela)",
    "address": "Rúa de Gómez Ulla, 8",
    "city": "Santiago de Compostela",
    "postcode": "15702",
    "countryCode": "ES",
    "country": "Spain",
    "telephone": "+34 981 59 10 64",
    "email": "info@estudio-54.com",
    "website": "https://estudio-54.com/",
    "latitude": 42.8752,
    "longitude": -8.543598,
    "id": "18ab77ef8361",
    "searchPlaces": [
      "Santiago de Compostela"
    ],
    "status": "active"
  },
  {
    "name": "Fanatic Guitars",
    "address": "Carrer de la Diputació, 282",
    "city": "Barcelona",
    "postcode": "08009",
    "countryCode": "ES",
    "country": "Spain",
    "telephone": "+34 933 23 88 31",
    "email": "",
    "website": "https://www.fanaticguitars.com/",
    "latitude": 41.392047,
    "longitude": 2.169435,
    "id": "2dd11b18ecc8",
    "searchPlaces": [
      "Dreta de l'Eixample",
      "Eixample",
      "Barcelona",
      "Ciutat Vella",
      "Sagrada Família",
      "Sagrada Familia",
      "Gràcia",
      "Gracia"
    ],
    "status": "active"
  },
  {
    "name": "Grup Vivaldi Rock i Clàssica",
    "address": "Carrer Nou 186",
    "city": "Figueres",
    "postcode": "17600",
    "countryCode": "ES",
    "country": "Spain",
    "telephone": "+34 972 670 946",
    "email": "figueres@grupvivaldi.com",
    "website": "http://grupvivaldi.com/",
    "latitude": 41.9836025,
    "longitude": 2.8189052,
    "id": "f69498d47287",
    "searchPlaces": [
      "Girona"
    ],
    "status": "active"
  },
  {
    "name": "Guitar Hiro",
    "address": "Calle del Cardenal Silíceo, 19",
    "city": "Madrid",
    "postcode": "28002",
    "countryCode": "ES",
    "country": "Spain",
    "telephone": "+34 648 26 66 75",
    "email": "",
    "website": "http://www.guitar-hiro.com/",
    "latitude": 40.4458618,
    "longitude": -3.6727798,
    "id": "11fd05bd5948",
    "searchPlaces": [
      "Ciudad Jardín",
      "Ciudad Jardin",
      "Ciudad Lineal",
      "Chamartín",
      "Chamartin",
      "Salamanca",
      "Tetuán de las Victorias",
      "Tetuan de las Victorias"
    ],
    "status": "active"
  },
  {
    "name": "Guitarshop Barcelona",
    "address": "Carrer dels Tallers 46",
    "city": "Barcelona",
    "postcode": "08001",
    "countryCode": "ES",
    "country": "Spain",
    "telephone": "+34 934 126 622",
    "email": "guitarshop@guitarshop.es",
    "website": "https://guitarshop.es/",
    "latitude": 41.3849011,
    "longitude": 2.1676486,
    "id": "0a5f4ac6dbb5",
    "searchPlaces": [
      "el Raval",
      "Eixample",
      "Ciutat Vella",
      "Barcelona",
      "la Nova Esquerra de l'Eixample",
      "Sants-Montjuïc",
      "Sants-Montjuic",
      "Gràcia",
      "Gracia"
    ],
    "status": "active"
  },
  {
    "name": "Hellbilly Center",
    "address": "P.º de Altamira, 306",
    "city": "Santander",
    "postcode": "39007",
    "countryCode": "ES",
    "country": "Spain",
    "telephone": "+34 942 76 64 54",
    "email": "",
    "website": "https://www.facebook.com/HellbillyCenterSantander",
    "latitude": 43.4623296,
    "longitude": -3.8281573,
    "id": "4af41ab764c4",
    "searchPlaces": [
      "Santander",
      "Torrelavega"
    ],
    "status": "active"
  },
  {
    "name": "HVC Music Import",
    "address": "Carrer Benimaclet, 37",
    "city": "Alboraya",
    "postcode": "46120",
    "countryCode": "ES",
    "country": "Spain",
    "telephone": "+34 960 03 75 09",
    "email": "info@hvcimport.com",
    "website": "https://hvcimport.com/contacto/",
    "latitude": 39.4628376,
    "longitude": -0.3758885,
    "id": "539967917577",
    "searchPlaces": [
      "Valencia",
      "Paterna",
      "Torrent",
      "Grao de Murviedro",
      "Sagunto"
    ],
    "status": "active"
  },
  {
    "name": "Madrid Musical Malaga8",
    "address": "C. de Málaga, 8",
    "city": "Madrid",
    "postcode": "28003",
    "countryCode": "ES",
    "country": "Spain",
    "telephone": "+34 914 42 72 22",
    "email": "info@malaga8.com",
    "website": "https://www.malaga8.com/",
    "latitude": 40.4387019,
    "longitude": -3.6933378,
    "id": "74a0adf8fb0e",
    "searchPlaces": [
      "Rios Rosas",
      "Chamberí",
      "Chamberi",
      "Salamanca",
      "Tetuán de las Victorias",
      "Tetuan de las Victorias",
      "Madrid Centro",
      "Madrid"
    ],
    "status": "active"
  },
  {
    "name": "Musical Pontevedra",
    "address": "Rúa do Pintor Laxeiro, 30",
    "city": "Pontevedra",
    "postcode": "36004",
    "countryCode": "ES",
    "country": "Spain",
    "telephone": "+34 986 86 56 77",
    "email": "info@musicalpontevedra.es",
    "website": "https://www.musicalpontevedra.es/",
    "latitude": 42.42502,
    "longitude": -8.632,
    "id": "b189913d1ada",
    "searchPlaces": [
      "Pontevedra",
      "Vigo"
    ],
    "status": "active"
  },
  {
    "name": "Musical Vigo",
    "address": "Bajada a Plaza Eliptica, Rúa de Fernando Conde, 17",
    "city": "Vigo",
    "postcode": "36202",
    "countryCode": "ES",
    "country": "Spain",
    "telephone": "+34 986 41 18 80",
    "email": "info@musicalpontevedra.es",
    "website": "https://www.musicalpontevedra.es/",
    "latitude": 42.2315497,
    "longitude": -8.7299844,
    "id": "f0559a26427d",
    "searchPlaces": [
      "Vigo",
      "Pontevedra"
    ],
    "status": "active"
  },
  {
    "name": "Musimaster Musical Instruments",
    "address": "C. Parque de las Ciencias, 1",
    "city": "Granada",
    "postcode": "18006",
    "countryCode": "ES",
    "country": "Spain",
    "telephone": "+34 958 27 30 30",
    "email": "",
    "website": "https://www.musimaster.com/",
    "latitude": 37.175554,
    "longitude": -3.607581,
    "id": "4da2fc405b59",
    "searchPlaces": [
      "Granada"
    ],
    "status": "active"
  },
  {
    "name": "Nova Era Music",
    "address": "Av. Seneca Esq, Av. Ildefonso Marañón Lavín",
    "city": "Seville",
    "postcode": "41019",
    "countryCode": "ES",
    "country": "Spain",
    "telephone": "+34 955 15 52 62",
    "email": "contacto@novaeramusica.com",
    "website": "https://novaeramusica.com/",
    "latitude": 37.4124387,
    "longitude": -5.9216906,
    "id": "7b6968509065",
    "searchPlaces": [
      "Valdezorras",
      "Sevilla",
      "Alcalá de Guadaira",
      "Alcala de Guadaira",
      "Dos Hermanas",
      "Utrera"
    ],
    "status": "active"
  },
  {
    "name": "Organigrama Guitars",
    "address": "Av. de Carlos Haya, 35",
    "city": "Málaga",
    "postcode": "29010",
    "countryCode": "ES",
    "country": "Spain",
    "telephone": "+34 952 28 70 48",
    "email": "info@organigramaguitars.com",
    "website": "http://www.organigramaguitars.com/",
    "latitude": 36.7216469,
    "longitude": -4.4460712,
    "id": "cfea41352a84",
    "searchPlaces": [
      "Málaga",
      "Malaga",
      "Torremolinos",
      "Benalmádena",
      "Benalmadena",
      "Mijas",
      "Fuengirola"
    ],
    "status": "active"
  },
  {
    "name": "Rockbox",
    "address": "Rúa José Luis Pérez Cepeda, 28",
    "city": "A Coruña",
    "postcode": "15004",
    "countryCode": "ES",
    "country": "Spain",
    "telephone": "+34 881 88 83 91",
    "email": "",
    "website": "https://rockbox.es/",
    "latitude": 43.3654965,
    "longitude": -8.4133751,
    "id": "70ddf04b6f85",
    "searchPlaces": [
      "A Coruña",
      "A Coruna",
      "Ferrol"
    ],
    "status": "active"
  },
  {
    "name": "Stringsfield Guitars",
    "address": "Los Pedrones Nº5, Bajo Izquierda",
    "city": "València",
    "postcode": "46017",
    "countryCode": "ES",
    "country": "Spain",
    "telephone": "",
    "email": "",
    "website": "http://www.stringsfield.com/",
    "latitude": 39.450425,
    "longitude": -0.390909,
    "id": "383cf9313d28",
    "searchPlaces": [
      "Sedaví",
      "Sedavi",
      "Valencia",
      "Torrent",
      "Paterna",
      "Grao de Murviedro",
      "Sagunto"
    ],
    "status": "closed"
  },
  {
    "name": "Txirula Musik",
    "address": "Pol. Ertzilla, 5 Par 20",
    "city": "Iurreta",
    "postcode": "48215",
    "countryCode": "ES",
    "country": "Spain",
    "telephone": "+34 946 81 14 43",
    "email": "info@txirula.com",
    "website": "http://www.txirula.com/",
    "latitude": 43.178482,
    "longitude": -2.644109,
    "id": "9e06dc077d79",
    "searchPlaces": [
      "Iurreta",
      "Santutxu",
      "Bilbao"
    ],
    "status": "active"
  },
  {
    "name": "VIAN MUSIC",
    "address": "C. Juan XXIII, 9",
    "city": "Ubrique",
    "postcode": "11600",
    "countryCode": "ES",
    "country": "Spain",
    "telephone": "+34 956 46 13 15",
    "email": "info@vianmusic.es",
    "website": "http://vianmusic.es/",
    "latitude": 36.6774269,
    "longitude": -5.4455569,
    "id": "058e91d0b981",
    "searchPlaces": [
      "Ubrique"
    ],
    "status": "active"
  },
  {
    "name": "Andy's Music Shop",
    "address": "Seestrasse 96",
    "city": "Uster",
    "postcode": "8610",
    "countryCode": "CH",
    "country": "Switzerland",
    "telephone": "+41 44 940 85 51",
    "email": "",
    "website": "http://www.andys-musicshop.ch/",
    "latitude": 47.3453221,
    "longitude": 8.6981745,
    "id": "27b795811d32",
    "searchPlaces": [
      "Uster / Nieder-Uster",
      "Zürich",
      "Zuerich",
      "Zürich (Kreis 11)",
      "Zuerich (Kreis 11)",
      "Winterthur"
    ],
    "status": "uncertain"
  },
  {
    "name": "ARK Guitars & Music Shop AG",
    "address": "Bertschikerstrasse 2",
    "city": "Wetzikon",
    "postcode": "8620",
    "countryCode": "CH",
    "country": "Switzerland",
    "telephone": "",
    "email": "info@arkguitars.ch",
    "website": "http://www.arkguitars.ch/",
    "latitude": 47.32436,
    "longitude": 8.7854962,
    "id": "e37844d1b210",
    "searchPlaces": [
      "Widum",
      "Zürich",
      "Zuerich",
      "Winterthur",
      "Zürich (Kreis 11)",
      "Zuerich (Kreis 11)"
    ],
    "status": "closed"
  },
  {
    "name": "Backstage Music GmbH",
    "address": "Tösstalstrasse 77",
    "city": "Winterthur",
    "postcode": "8400",
    "countryCode": "CH",
    "country": "Switzerland",
    "telephone": "+41 52 558 37 70",
    "email": "info@backstagemusic.ch",
    "website": "http://www.backstagemusic.ch/",
    "latitude": 47.4938514,
    "longitude": 8.7421989,
    "id": "00cdb197714c",
    "searchPlaces": [
      "Mattenbach (Kreis 7) / Deutweg",
      "Winterthur",
      "Zürich (Kreis 11)",
      "Zuerich (Kreis 11)",
      "Zürich",
      "Zuerich"
    ],
    "status": "active"
  },
  {
    "name": "Baff Music",
    "address": "Thunstrasse 32",
    "city": "Spiez",
    "postcode": "3700",
    "countryCode": "CH",
    "country": "Switzerland",
    "telephone": "+41 33 654 77 49",
    "email": "bigbaff@baff.ch",
    "website": "http://www.baff.ch/",
    "latitude": 46.6899852,
    "longitude": 7.6714262,
    "id": "9b21f31447f2",
    "searchPlaces": [
      "Spiez"
    ],
    "status": "active"
  },
  {
    "name": "Blue Wonder",
    "address": "Churerstrasse 15",
    "city": "Buchs",
    "postcode": "9470",
    "countryCode": "CH",
    "country": "Switzerland",
    "telephone": "+41 81 756 71 72",
    "email": "info@bluewonder.ch",
    "website": "http://www.bluewonder.ch/",
    "latitude": 47.163105,
    "longitude": 9.4749061,
    "id": "5d02d4b3970f",
    "searchPlaces": [
      "Buchs",
      "Sankt Gallen"
    ],
    "status": "active"
  },
  {
    "name": "Boullard Musique SA",
    "address": "Av. de Riond-Bosson 10",
    "city": "Morges",
    "postcode": "1110",
    "countryCode": "CH",
    "country": "Switzerland",
    "telephone": "+41 21 811 28 28",
    "email": "contact@boullard.ch",
    "website": "http://www.boullard.ch/",
    "latitude": 46.504643,
    "longitude": 6.485431,
    "id": "dad23c33fb53",
    "searchPlaces": [
      "Morges",
      "Lausanne"
    ],
    "status": "active"
  },
  {
    "name": "Dimensione Musica Sagl",
    "address": "Via Vincenzo Vela 8",
    "city": "Locarno",
    "postcode": "6600",
    "countryCode": "CH",
    "country": "Switzerland",
    "telephone": "+41 76 630 35 38",
    "email": "info@dimensionemusica.ch",
    "website": "https://www.dimensionemusica.ch/",
    "latitude": 46.166588,
    "longitude": 8.79538,
    "id": "c921e83d97ce",
    "searchPlaces": [
      "Locarno",
      "Lugano"
    ],
    "status": "active"
  },
  {
    "name": "Gitarren Total AG",
    "address": "Aemtlerstrasse 15",
    "city": "Zürich",
    "postcode": "8003",
    "countryCode": "CH",
    "country": "Switzerland",
    "telephone": "+41 44 463 16 16",
    "email": "info@gitarrentotal.ch",
    "website": "http://www.gitarrentotal.ch/",
    "latitude": 47.371145,
    "longitude": 8.516217,
    "id": "db478a32e13c",
    "searchPlaces": [
      "Zürich (Kreis 3) / Sihlfeld",
      "Zuerich (Kreis 3) / Sihlfeld",
      "Zürich",
      "Zuerich",
      "Zürich (Kreis 11)",
      "Zuerich (Kreis 11)",
      "Winterthur"
    ],
    "status": "active"
  },
  {
    "name": "Guitar Store Manea",
    "address": "Hof 5",
    "city": "Ibach",
    "postcode": "6438",
    "countryCode": "CH",
    "country": "Switzerland",
    "telephone": "+41 41 810 23 23",
    "email": "info@guitarstore.ch",
    "website": "http://www.guitarstore.ch/",
    "latitude": 47.012231,
    "longitude": 8.645384,
    "id": "f80ad552fabf",
    "searchPlaces": [
      "Ibach",
      "Luzern"
    ],
    "status": "active"
  },
  {
    "name": "Guitars & Repairs Winkler GmbH",
    "address": "Karmaad 20",
    "city": "Gams",
    "postcode": "9473",
    "countryCode": "CH",
    "country": "Switzerland",
    "telephone": "+41 81 771 16 39",
    "email": "info@grwg.ch",
    "website": "https://www.grwg.ch/",
    "latitude": 47.203789,
    "longitude": 9.452084,
    "id": "6d17add9168c",
    "searchPlaces": [
      "Gams",
      "Sankt Gallen"
    ],
    "status": "active"
  },
  {
    "name": "Klangstudio",
    "address": "Brünigstrasse 82",
    "city": "Giswil",
    "postcode": "6074",
    "countryCode": "CH",
    "country": "Switzerland",
    "telephone": "+41 41 675 16 28",
    "email": "",
    "website": "http://klangstudio.ch/",
    "latitude": 46.8329722,
    "longitude": 8.1835721,
    "id": "69c951f2beb3",
    "searchPlaces": [
      "Giswil",
      "Luzern"
    ],
    "status": "active"
  },
  {
    "name": "Le Flon - Lausanne - Quartier commerçant",
    "address": "",
    "city": "Lausanne",
    "postcode": "1003",
    "countryCode": "CH",
    "country": "Switzerland",
    "telephone": "",
    "email": "",
    "website": "",
    "latitude": 46.521485,
    "longitude": 6.6292176,
    "id": "ad825776611c",
    "searchPlaces": [
      "Lausanne"
    ],
    "status": "uncertain"
  },
  {
    "name": "Lüscher Musik AG",
    "address": "Baslerstrasse 27",
    "city": "Oftringen",
    "postcode": "4665",
    "countryCode": "CH",
    "country": "Switzerland",
    "telephone": "+41 62 797 50 88",
    "email": "info@lueschermusik.ch",
    "website": "http://www.lueschermusik.ch/",
    "latitude": 47.314754,
    "longitude": 7.916778,
    "id": "e61dbe227c1e",
    "searchPlaces": [
      "Oftringen"
    ],
    "status": "active"
  },
  {
    "name": "Montana Music GmbH",
    "address": "Tonhallestrasse 1",
    "city": "Wil SG",
    "postcode": "9500",
    "countryCode": "CH",
    "country": "Switzerland",
    "telephone": "+41 71 999 07 06",
    "email": "info@montanamusic.ch",
    "website": "https://www.montanamusic.ch/",
    "latitude": 47.4650782,
    "longitude": 9.0483461,
    "id": "955d1483b847",
    "searchPlaces": [
      "Wil",
      "Winterthur",
      "Sankt Gallen"
    ],
    "status": "active"
  },
  {
    "name": "Musikschule Music Center Grenchen",
    "address": "Bielstrasse",
    "city": "Grenchen",
    "postcode": "2540",
    "countryCode": "CH",
    "country": "Switzerland",
    "telephone": "+41 32 652 22 77",
    "email": "mcmusikschule21@gmail.com",
    "website": "https://www.musikschule-mc-grenchen.ch/kontakt/",
    "latitude": 47.1920862,
    "longitude": 7.3956597,
    "id": "b2aaab7a3f9b",
    "searchPlaces": [
      "Grenchen",
      "Biel/Bienne",
      "Bern"
    ],
    "status": "active"
  },
  {
    "name": "Music Store - 1196 Gland | VINTAGE AND CURRENT",
    "address": "Rue de Riant-Coteau 11",
    "city": "Gland",
    "postcode": "1196",
    "countryCode": "CH",
    "country": "Switzerland",
    "telephone": "+41 79 632 72 19",
    "email": "info@magasinmusiquegland.ch",
    "website": "http://www.magasinmusiquegland.ch/",
    "latitude": 46.418491,
    "longitude": 6.2822431,
    "id": "af328585ff5b",
    "searchPlaces": [
      "Gland",
      "Geneva",
      "Lausanne"
    ],
    "status": "active"
  },
  {
    "name": "Musiconnection di Pucci Moreno",
    "address": "Viale Officina 9",
    "city": "Bellinzona",
    "postcode": "6500",
    "countryCode": "CH",
    "country": "Switzerland",
    "telephone": "+41 91 826 26 15",
    "email": "",
    "website": "http://www.musiconnection.ch/",
    "latitude": 46.197559,
    "longitude": 9.027692,
    "id": "af6000ead7f4",
    "searchPlaces": [
      "Bellinzona",
      "Lugano"
    ],
    "status": "closed"
  },
  {
    "name": "Musik Althaus AG",
    "address": "Thunstrasse 3",
    "city": "Schwarzenburg",
    "postcode": "3150",
    "countryCode": "CH",
    "country": "Switzerland",
    "telephone": "+41 31 731 22 20",
    "email": "info@musikalthaus.ch",
    "website": "http://www.musikalthaus.ch/",
    "latitude": 46.818498,
    "longitude": 7.34434,
    "id": "e010ed18c366",
    "searchPlaces": [
      "Heitenried",
      "Bern"
    ],
    "status": "active"
  },
  {
    "name": "Music Center Sursee GmbH",
    "address": "Bahnhofstrasse 39",
    "city": "Sursee",
    "postcode": "6210",
    "countryCode": "CH",
    "country": "Switzerland",
    "telephone": "+41 41 920 46 06",
    "email": "",
    "website": "",
    "latitude": 47.17149,
    "longitude": 8.0998,
    "id": "69d593bcf83b",
    "searchPlaces": [
      "Sursee",
      "Luzern"
    ],
    "status": "closed"
  },
  {
    "name": "Musik Hug AG",
    "address": "Innere Margarethenstrasse 6",
    "city": "Basel",
    "postcode": "4051",
    "countryCode": "CH",
    "country": "Switzerland",
    "telephone": "+41 61 272 33 90",
    "email": "online@musikhug.ch",
    "website": "https://www.musikhug.ch/",
    "latitude": 47.546059,
    "longitude": 7.555675,
    "id": "5e13859e43db",
    "searchPlaces": [
      "Binningen",
      "Basel"
    ],
    "status": "active"
  },
  {
    "name": "Musik Melody Solothurn",
    "address": "Rossmarktpl. 1",
    "city": "Solothurn",
    "postcode": "4500",
    "countryCode": "CH",
    "country": "Switzerland",
    "telephone": "+41 32 623 75 70",
    "email": "thun@musikmelody.ch",
    "website": "http://www.musikmelody.ch/",
    "latitude": 47.204594,
    "longitude": 7.536753,
    "id": "7aacab14f2c8",
    "searchPlaces": [
      "Solothurn",
      "Biel/Bienne",
      "Bern"
    ],
    "status": "active"
  },
  {
    "name": "Musik Müller AG",
    "address": "Zeughausgasse 22",
    "city": "Bern",
    "postcode": "3011",
    "countryCode": "CH",
    "country": "Switzerland",
    "telephone": "+41 31 311 41 34",
    "email": "info@musikmueller.ch",
    "website": "https://www.musikmueller.ch/",
    "latitude": 46.9491937,
    "longitude": 7.4450164,
    "id": "df4a52ea54c3",
    "searchPlaces": [
      "Bern",
      "Biel/Bienne"
    ],
    "status": "active"
  },
  {
    "name": "Musik Schärz Klassik Orgelhaus",
    "address": "Oberlandstrasse 109",
    "city": "Uster",
    "postcode": "8610",
    "countryCode": "CH",
    "country": "Switzerland",
    "telephone": "+41 44 940 30 56",
    "email": "",
    "website": "https://musikschaerz.ch/",
    "latitude": 47.3521441,
    "longitude": 8.7198558,
    "id": "bf7be7a8eafb",
    "searchPlaces": [
      "Uster",
      "Zürich",
      "Zuerich",
      "Zürich (Kreis 11)",
      "Zuerich (Kreis 11)",
      "Winterthur"
    ],
    "status": "active"
  },
  {
    "name": "Musikhaus Krebs AG",
    "address": "Untergasse 36",
    "city": "Biel/Bienne",
    "postcode": "2502",
    "countryCode": "CH",
    "country": "Switzerland",
    "telephone": "+41 32 322 93 13",
    "email": "info@musik-krebs.ch",
    "website": "http://www.musik-krebs.ch/",
    "latitude": 47.141706,
    "longitude": 7.2473445,
    "id": "c6d70f02a878",
    "searchPlaces": [
      "Biel/Bienne",
      "Bern"
    ],
    "status": "active"
  },
  {
    "name": "Musikhaus Saitensprung",
    "address": "Unterstadt 27",
    "city": "Schaffhausen",
    "postcode": "8200",
    "countryCode": "CH",
    "country": "Switzerland",
    "telephone": "+41 52 625 81 11",
    "email": "info@saitensprung.ch",
    "website": "http://www.saitensprung.ch/",
    "latitude": 47.6957353,
    "longitude": 8.6389044,
    "id": "7685272f24e8",
    "searchPlaces": [
      "Schaffhausen",
      "Winterthur"
    ],
    "status": "active"
  },
  {
    "name": "MusiX AG",
    "address": "Sägeweg 15",
    "city": "Giebenach",
    "postcode": "4304",
    "countryCode": "CH",
    "country": "Switzerland",
    "telephone": "+41 61 813 11 77",
    "email": "",
    "website": "http://www.musix.com/",
    "latitude": 47.5252782,
    "longitude": 7.7422276,
    "id": "7e8f22c8b332",
    "searchPlaces": [
      "Kaiseraugst",
      "Basel"
    ],
    "status": "active"
  },
  {
    "name": "Pat's Instrumenten-Shop",
    "address": "Rüegsaustrasse 21",
    "city": "Rüegsauschachen",
    "postcode": "3415",
    "countryCode": "CH",
    "country": "Switzerland",
    "telephone": "+41 34 461 02 32",
    "email": "info@patsinstrumentenshop.ch",
    "website": "https://www.patsinstrumentenshop.ch/",
    "latitude": 47.0180698,
    "longitude": 7.6594834,
    "id": "379aef9152e4",
    "searchPlaces": [
      "Rüegsau",
      "Rueegsau",
      "Bern"
    ],
    "status": "active"
  },
  {
    "name": "Planetmusic GmbH",
    "address": "Goldgasse 2",
    "city": "Balsthal",
    "postcode": "4710",
    "countryCode": "CH",
    "country": "Switzerland",
    "telephone": "+41 62 530 15 87",
    "email": "",
    "website": "https://www.planetmusic.ch/",
    "latitude": 47.3162974,
    "longitude": 7.6958231,
    "id": "aea0b9fcaf57",
    "searchPlaces": [
      "Balsthal",
      "Basel"
    ],
    "status": "active"
  },
  {
    "name": "Portier & Gaudin Musique SA",
    "address": "Av. du Funiculaire 1",
    "city": "Cossonay-Ville",
    "postcode": "1304",
    "countryCode": "CH",
    "country": "Switzerland",
    "telephone": "+41 21 861 07 65",
    "email": "musique@portier-gaudin.ch",
    "website": "https://www.portier-gaudin.ch/",
    "latitude": 46.61346,
    "longitude": 6.50865,
    "id": "4de71c37ef4f",
    "searchPlaces": [
      "Cossonay",
      "Lausanne"
    ],
    "status": "active"
  },
  {
    "name": "Promusig - the music store",
    "address": "Sihlfeldstrasse 138",
    "city": "Zürich",
    "postcode": "8004",
    "countryCode": "CH",
    "country": "Switzerland",
    "telephone": "+41 44 241 40 20",
    "email": "info@promusig.ch",
    "website": "https://promusig.ch/",
    "latitude": 47.3789081,
    "longitude": 8.516245,
    "id": "835725692143",
    "searchPlaces": [
      "Zürich (Kreis 4) / Aussersihl",
      "Zuerich (Kreis 4) / Aussersihl",
      "Zürich",
      "Zuerich",
      "Zürich (Kreis 11)",
      "Zuerich (Kreis 11)",
      "Winterthur"
    ],
    "status": "active"
  },
  {
    "name": "Rappi Musig Musikschule & Shop",
    "address": "Obere Bahnhofstrasse 56",
    "city": "Rapperswil-Jona",
    "postcode": "8640",
    "countryCode": "CH",
    "country": "Switzerland",
    "telephone": "+41 55 210 22 25",
    "email": "",
    "website": "http://www.rappimusig.ch/",
    "latitude": 47.2278467,
    "longitude": 8.8197293,
    "id": "8d804061338f",
    "searchPlaces": [
      "Rapperswil",
      "Zürich",
      "Zuerich"
    ],
    "status": "active"
  },
  {
    "name": "Rock-Factory",
    "address": "Gliserallee 107",
    "city": "Brig",
    "postcode": "3902",
    "countryCode": "CH",
    "country": "Switzerland",
    "telephone": "+41 79 462 23 00",
    "email": "info@rock-factory.ch",
    "website": "http://www.rock-factory.ch/",
    "latitude": 46.3123027,
    "longitude": 7.9812556,
    "id": "773cfe58147a",
    "searchPlaces": [
      "Brig"
    ],
    "status": "active"
  },
  {
    "name": "Seedamm Music Store",
    "address": "Churerstrasse 162",
    "city": "Pfäffikon SZ",
    "postcode": "8808",
    "countryCode": "CH",
    "country": "Switzerland",
    "telephone": "+41 55 420 17 17",
    "email": "info@seedamm-music.ch",
    "website": "http://www.seedamm-music.ch/",
    "latitude": 47.201311,
    "longitude": 8.799253,
    "id": "15da297b95cc",
    "searchPlaces": [
      "Pfäffikon",
      "Pfaeffikon",
      "Zürich",
      "Zuerich"
    ],
    "status": "closed"
  },
  {
    "name": "Sound am Albis",
    "address": "Haldenstrasse 11",
    "city": "Hedingen",
    "postcode": "8908",
    "countryCode": "CH",
    "country": "Switzerland",
    "telephone": "+41 78 775 79 18",
    "email": "soundamalbis@bluewin.ch",
    "website": "https://soundamalbis.ch/",
    "latitude": 47.2970023,
    "longitude": 8.4494936,
    "id": "2c6ab5d28b43",
    "searchPlaces": [
      "Hedingen",
      "Zürich",
      "Zuerich",
      "Zürich (Kreis 11)",
      "Zuerich (Kreis 11)",
      "Luzern"
    ],
    "status": "active"
  },
  {
    "name": "the musical box, music school & instruments",
    "address": "Ob. Halde 27",
    "city": "Baden",
    "postcode": "5400",
    "countryCode": "CH",
    "country": "Switzerland",
    "telephone": "+41 56 222 00 60",
    "email": "info@musicalbox.ch",
    "website": "http://www.musicalbox.ch/",
    "latitude": 47.472396,
    "longitude": 8.309131,
    "id": "a0645e0527e8",
    "searchPlaces": [
      "Baden",
      "Zürich (Kreis 11)",
      "Zuerich (Kreis 11)",
      "Zürich",
      "Zuerich"
    ],
    "status": "active"
  },
  {
    "name": "The Works SA",
    "address": "Rue Joseph-Girard 10",
    "city": "Carouge",
    "postcode": "1227",
    "countryCode": "CH",
    "country": "Switzerland",
    "telephone": "+41 22 300 13 93",
    "email": "info@theworks.ch",
    "website": "http://www.theworks.ch/",
    "latitude": 46.1811979,
    "longitude": 6.1402019,
    "id": "237b4e4d86eb",
    "searchPlaces": [
      "Carouge",
      "Geneva"
    ],
    "status": "active"
  },
  {
    "name": "Unisono GmbH",
    "address": "Schulgässli 20",
    "city": "Steffisburg",
    "postcode": "3612",
    "countryCode": "CH",
    "country": "Switzerland",
    "telephone": "+41 33 437 24 24",
    "email": "info@unisono.ch",
    "website": "http://www.unisono.ch/",
    "latitude": 46.780383,
    "longitude": 7.63483,
    "id": "22f6fff7068b",
    "searchPlaces": [
      "Steffisburg",
      "Bern"
    ],
    "status": "active"
  },
  {
    "name": "Apollo Music",
    "address": "8 Princes Pavement",
    "city": "Birkenhead",
    "postcode": "CH41 2XY",
    "countryCode": "GB",
    "country": "United Kingdom",
    "telephone": "+44 151 650 1030",
    "email": "info@apollomusiconline.co.uk",
    "website": "http://www.apollomusiconline.co.uk/",
    "latitude": 53.3907569,
    "longitude": -3.0225381,
    "id": "3da5a23a026a",
    "searchPlaces": [
      "Birkenhead",
      "Liverpool",
      "Bebington",
      "Wallasey",
      "Bootle",
      "Huyton",
      "Ellesmere Port Town",
      "Widnes"
    ],
    "status": "active"
  },
  {
    "name": "Badlands Guitars Ltd",
    "address": "46 Preston Rd",
    "city": "Brighton",
    "postcode": "BN1 4QF",
    "countryCode": "GB",
    "country": "United Kingdom",
    "telephone": "+44 1273 673363",
    "email": "badlandsguitars@gmail.com",
    "website": "http://www.badlandsguitars.co.uk/",
    "latitude": 50.834751,
    "longitude": -0.140465,
    "id": "bddde59a49ef",
    "searchPlaces": [
      "Brighton",
      "Hove",
      "Worthing",
      "Littlehampton",
      "Horsham"
    ],
    "status": "active"
  },
  {
    "name": "Coda Music",
    "address": "51A High St",
    "city": "Stevenage",
    "postcode": "SG1 3AH",
    "countryCode": "GB",
    "country": "United Kingdom",
    "telephone": "+44 1438 350815",
    "email": "",
    "website": "http://www.coda-music.com/",
    "latitude": 51.9113449,
    "longitude": -0.207863,
    "id": "a27d5af2d786",
    "searchPlaces": [
      "Stevenage",
      "Welwyn Garden City",
      "Luton",
      "St Albans",
      "Dunstable",
      "Hemel Hempstead",
      "Harlow"
    ],
    "status": "active"
  },
  {
    "name": "Forsyth Music Shop",
    "address": "126 Deansgate",
    "city": "Manchester",
    "postcode": "M3 2GR",
    "countryCode": "GB",
    "country": "United Kingdom",
    "telephone": "+44 161 834 3281",
    "email": "",
    "website": "https://www.forsyths.co.uk/",
    "latitude": 53.4811861,
    "longitude": -2.2479345,
    "id": "2bb1aa686aa1",
    "searchPlaces": [
      "Manchester City Centre",
      "Manchester",
      "Salford",
      "Sale",
      "Stockport",
      "Oldham",
      "Bury",
      "Rochdale"
    ],
    "status": "active"
  },
  {
    "name": "Guitar Super Store",
    "address": "42-45 Station St",
    "city": "Burton-on-Trent",
    "postcode": "DE14 1AX",
    "countryCode": "GB",
    "country": "United Kingdom",
    "telephone": "+44 1283 500366",
    "email": "info@guitarsuperstore.com",
    "website": "http://www.guitarsuperstore.net/",
    "latitude": 52.8037505,
    "longitude": -1.6334201,
    "id": "f9959b6a7bed",
    "searchPlaces": [
      "Burton upon Trent",
      "Derby",
      "Tamworth",
      "Sutton Coldfield",
      "Loughborough",
      "Cannock"
    ],
    "status": "active"
  },
  {
    "name": "Jimmy Egypt and Sons Musical Instruments",
    "address": "615 Great Western Road",
    "city": "Glasgow",
    "postcode": "G12 8HX",
    "countryCode": "GB",
    "country": "United Kingdom",
    "telephone": "+44 141 339 2941",
    "email": "shop@jimmyegypt.com",
    "website": "https://www.jimmyegypt.com/",
    "latitude": 55.876477,
    "longitude": -4.2857583,
    "id": "613798fec905",
    "searchPlaces": [
      "Glasgow",
      "Paisley",
      "East Kilbride",
      "Hamilton",
      "Cumbernauld",
      "Meikle Earnock"
    ],
    "status": "active"
  },
  {
    "name": "Listers Guitars",
    "address": "64 High St",
    "city": "Lowestoft",
    "postcode": "NR32 1JB",
    "countryCode": "GB",
    "country": "United Kingdom",
    "telephone": "+44 1502 565491",
    "email": "sales@listersguitars.co.uk",
    "website": "http://www.listersguitars.co.uk/",
    "latitude": 52.4817759,
    "longitude": 1.7559563,
    "id": "88fc8f1d4dee",
    "searchPlaces": [
      "Lowestoft",
      "Great Yarmouth"
    ],
    "status": "active"
  },
  {
    "name": "Mak's Guitars",
    "address": "4-11 Galen Pl",
    "city": "London",
    "postcode": "WC1A 2JR",
    "countryCode": "GB",
    "country": "United Kingdom",
    "telephone": "+44 20 7018 2370",
    "email": "",
    "website": "http://www.maksguitars.co.uk/",
    "latitude": 51.5165425,
    "longitude": -0.1332726,
    "id": "1ddd302b0184",
    "searchPlaces": [
      "Soho",
      "London",
      "City of Westminster",
      "Islington",
      "Chelsea",
      "Battersea",
      "Archway",
      "Brixton"
    ],
    "status": "active"
  },
  {
    "name": "R & T Music",
    "address": "8 Dalkeith St",
    "city": "Barrow-in-Furness",
    "postcode": "LA14 1SP",
    "countryCode": "GB",
    "country": "United Kingdom",
    "telephone": "+44 1229 826344",
    "email": "info@randtmusic.co.uk",
    "website": "http://www.randtmusic.co.uk/",
    "latitude": 54.1146172,
    "longitude": -3.2289026,
    "id": "021d0d684077",
    "searchPlaces": [
      "Barrow in Furness",
      "Morecambe"
    ],
    "status": "active"
  },
  {
    "name": "Sound Affects",
    "address": "129 New Ct Way",
    "city": "Ormskirk",
    "postcode": "L39 2YT",
    "countryCode": "GB",
    "country": "United Kingdom",
    "telephone": "+44 1695 570023",
    "email": "sales@soundaffects.com",
    "website": "http://www.soundaffects.com/",
    "latitude": 53.5713107,
    "longitude": -2.8816199,
    "id": "0fddcc10e527",
    "searchPlaces": [
      "Ormskirk",
      "Southport",
      "Bootle",
      "Wigan",
      "St Helens",
      "Huyton",
      "Liverpool",
      "Wallasey"
    ],
    "status": "active"
  },
  {
    "name": "The Guitar Tech",
    "address": "8 Senacre Square",
    "city": "Maidstone",
    "postcode": "ME15 8QF",
    "countryCode": "GB",
    "country": "United Kingdom",
    "telephone": "+44 1622 230664",
    "email": "info@theguitartech.co.uk",
    "website": "https://theguitartech.co.uk/",
    "latitude": 51.2498908,
    "longitude": 0.5594003,
    "id": "af810765d16e",
    "searchPlaces": [
      "Maidstone",
      "Chatham",
      "Gillingham",
      "Sittingbourne",
      "Royal Tunbridge Wells",
      "Ashford",
      "Gravesend",
      "Grays"
    ],
    "status": "active"
  },
  {
    "name": "Guitar Village",
    "address": "80-82 West St",
    "city": "Farnham",
    "postcode": "GU9 7EN",
    "countryCode": "GB",
    "country": "United Kingdom",
    "telephone": "+44 1252 726821",
    "email": "",
    "website": "https://guitarvillage.co.uk/",
    "latitude": 51.2134337,
    "longitude": -0.8045025,
    "id": "7c1ada3f6bf5",
    "searchPlaces": [
      "Farnham",
      "Farnborough",
      "Guildford",
      "Basingstoke",
      "Woking",
      "Bracknell",
      "Reading"
    ],
    "status": "active"
  },
  {
    "name": "The Woodshed Guitars",
    "address": "Mobbs Wood Farm, Brinklow Road",
    "city": "Coventry",
    "postcode": "CV7 9JN",
    "countryCode": "GB",
    "country": "United Kingdom",
    "telephone": "+44 7799 826787",
    "email": "woodshedguitarscoventry@gmail.com",
    "website": "http://thewoodshedguitars.co.uk/",
    "latitude": 52.440709,
    "longitude": -1.3759032,
    "id": "819bdf793a7a",
    "searchPlaces": [
      "Brinklow",
      "Coventry",
      "Rugby",
      "Hinckley",
      "Nuneaton",
      "Royal Leamington Spa",
      "Leicester",
      "Solihull"
    ],
    "status": "active"
  },
  {
    "name": "Windmill Guitars",
    "address": "51 High St",
    "city": "Bangor",
    "postcode": "BT20 5BE",
    "countryCode": "GB",
    "country": "United Kingdom",
    "telephone": "+44 28 9122 5324",
    "email": "info@windmillguitars.com",
    "website": "http://www.windmillguitars.com/",
    "latitude": 54.6636416,
    "longitude": -5.665034,
    "id": "d00eb7ba5672",
    "searchPlaces": [
      "Bangor",
      "Newtownabbey",
      "Castlereagh",
      "Belfast",
      "Lisburn"
    ],
    "status": "active"
  },
  {
    "name": "WM Guitars",
    "address": "3 West St",
    "city": "Newton Abbot",
    "postcode": "TQ13 7DT",
    "countryCode": "GB",
    "country": "United Kingdom",
    "telephone": "+44 1364 652333",
    "email": "enquiries@wmguitars.co.uk",
    "website": "http://www.wmguitars.co.uk/",
    "latitude": 50.515372,
    "longitude": -3.756094,
    "id": "d351f9c65009",
    "searchPlaces": [
      "Ashburton",
      "Paignton",
      "Torquay",
      "Exeter"
    ],
    "status": "active"
  },
  {
    "name": "String Taste",
    "address": "Bożego Ciała 10 LU1",
    "city": "Kraków",
    "postcode": "31-059",
    "countryCode": "PL",
    "country": "Poland",
    "telephone": "+48 791 440 144",
    "email": "hello@stringtaste.com",
    "website": "https://stringtaste.com/",
    "latitude": 50.0517825,
    "longitude": 19.9436083,
    "id": "stringtaste-krakow",
    "searchPlaces": [
      "Kraków",
      "Krakow"
    ],
    "status": "active"
  }
]);
